import Vue from 'vue'
import axios from 'axios'
import config from '../../config'
import Url from '../../util/url'
import router from '../../router'
import store from '../../store'

axios.defaults.baseURL = Url.getUrl()
axios.defaults.timeout = 30000
Vue.$log.debug(axios.defaults.baseURL)

const PREFIX_URL = '/api/v1'

const state = {
  isLogin: false,
  isAdmin: false,
  systemTime: {},
  currentUser: {},
  modalList: [],
  portCongList: [],
  modalData: [],
  fwUpdating: false,
  fwProgressStatus: 'none',
  progress: 0,
  showFullLoading: false,
  fwFileUpdateCompleted: false,
  fwinfo: {},
  about: {},
  systemHostInfo: {},
  sysBoard: {},
  portNum: 12,
  updateType: '',
  showErrors: false,
  countError: 0,
  showErrorWin: {show: false, data: {}, title: null},
  lagGroupMap: new Map(),
  portMap: new Map(),
  qswTimeout: null,
  isShowTimoutWin: {status: false, type: ''},
  reloadDeviceInfo: null,
  timeConfig: {
    time: {},
    timezone: null,
    isNTP: false
  },
  lagStartNum: 0,
  sensorStatus: null,
  portStatus: {},
  isFec: false
}

const instance = axios.create({
  baseURL: Url.getUrl()
  // withCredentials: true // allow cookie
})

instance.interceptors.response.use(
  function (response) {
    // Do something with response data
    state.countError = 0
    // store.commit('setErrorNum', true)
    return response
  },
  function (error) {
    // Do something with response error
    if (!error.response && (!store.state.app.loadingType || error.message === 'Network Error')) {
      if (!error.config.url.includes('/system/time') && !error.config.url.includes('/firmware/status') && !error.config.url.includes('/api/live')) {
        if (state.countError > 5) {
          store.commit('setLoadingType', '')
          store.commit('updateFullLoadingStatus', false)
          state.countError = 0
          store.dispatch('postLogout')
          router.push({
            name: 'login'
          })
          window.location.reload(true)
        } else {
          state.countError++
        }
      }
    } else if (error.response && (error.response.data.error_code === 401 || error.response.status === 401)) {
      if (!error.config.url.includes('/users/login') && !error.config.url.includes('/users/verification') && !error.config.url.includes('/users/exit')) {
        // show error win
        store.commit('setLoadingType', '')
        store.commit('updateFullLoadingStatus', false)
        store.commit('setErrorNum', false)
        store.commit('updateTimeoutWinStatus', {status: true, type: 'login'})
      }
    } else if (error.response && (error.response.data.error_code === 500 || error.response.status === 500) && !error.config.url.includes('/firmware/update/check')) {
      store.commit('setErrorWin', {
        show: true,
        data: (error.response.data) ? error.response.data : error.response,
        config: error.config,
        title: null
      })
    }
    return Promise.reject(error)
  }
)

var rpcseq = 0
let getid = () => (rpcseq += 1)

const module = {
  state,
  mutations: {
    login (state) {
      state.isLogin = true
    },
    logout (state) {
      state.isLogin = false
    },
    setCurrentUser (state, { user }) {
      Vue.$log.debug('setCurrentUser')
      state.currentUser = user
      if (user !== null) {
        if (user && user.groupname === 15) {
          state.isAdmin = true
          user.groupname = 'administrators'
        } else {
          state.isAdmin = false
          user.groupname = 'everyone'
        }
      }
    },
    renewAuth (state, auth) {
      Vue.$log.debug('renewAuth')
      state.currentUser.auth = auth
    },
    openModal (state, modalname) {
      state.modalList.push(modalname)
    },
    closeModal (state, modalname) {
      for (var i = 0; i < state.modalList.length; i++) {
        if (state.modalList[i] === modalname) {
          state.modalList.splice(i, 1)
        }
      }
    },
    setSystemBoard (state, boardInfo) {
      Vue.$log.debug('setSystemBoard')
      state.boardInfo = boardInfo
    },
    setModalData (state, data) {
      Vue.$log.debug('setModalData')
      state.modalData = data
    },
    setUpdateStatus (state, fwUpdating) {
      Vue.$log.debug('setUpdateStatus')
      state.fwUpdating = fwUpdating
    },
    setfwProgressStatus (state, status) {
      Vue.$log.debug('setfwProgressStatus')
      state.fwProgressStatus = status
    },
    setProgress (state, progress) {
      Vue.$log.debug('setProgress')
      state.progress = progress
    },
    updateFullLoadingStatus (state, showFullLoading) {
      Vue.$log.debug('updateFullLoadingStatus')
      state.showFullLoading = showFullLoading
    },
    updateFileStatus (state, status) {
      Vue.$log.debug('updateFileStatus')
      state.fwFileUpdateCompleted = status
    },
    updateFirmwareInfo (state, info) {
      Vue.$log.debug('updateFirmwareInfo')
      state.fwinfo = info
    },
    setAboutInfo (state, info) {
      Vue.$log.debug('setAboutInfo')
      state.about[info.key] = info.val
    },
    setPortNumber (state, number) {
      Vue.$log.debug('setPortNumber')
      state.portNum = number
    },
    setUpdateType (state, type) {
      Vue.$log.debug('setUpdateType')
      state.updateType = type
    },
    setErrorsPage (state, status) {
      Vue.$log.debug('setErrorsPage')
      state.showErrors = status
    },
    setErrorNum (state, status) {
      Vue.$log.debug('setErrorNum')
      if (status) {
        state.countError++
      } else {
        state.countError = 0
      }
    },
    setErrorWin (state, status) {
      state.showErrorWin = status
    },
    setSysHostInfo (state, info) {
      Vue.$log.debug('setSysHostInfo')
      state.systemHostInfo = info
    },
    setSysBoard (state, data) {
      Vue.$log.debug('setSysBoard')
      if (data.MacAddr.charAt(2) !== ':') {
        let Mac = [data.MacAddr.slice(0, 2), ':', data.MacAddr.slice(2, 4), ':', data.MacAddr.slice(4, 6), ':', data.MacAddr.slice(6, 8), ':', data.MacAddr.slice(8, 10), ':', data.MacAddr.slice(10, 12)].join('')
        data.MacAddr = Mac
      }
      state.sysBoard = data
    },
    updateTimeout (state, isRenew) {
      state.qswTimeout = new Date()
    },
    updateTimeoutWinStatus (state, status) {
      state.isShowTimoutWin = status
    },
    updateReloadDeviceStatus (state, status) {
      state.reloadDeviceInfo = status
    },
    setTimeconfig (state, data) {
      Vue.$log.debug('setTimeconfig')
      state.timeConfig[data.key] = data.val
    },
    setLagStartNumber (state, data) {
      Vue.$log.debug('setLagStartNumber')
      state.lagStartNum = data.StartIndex
    },
    setSensorStatus (state, status) {
      Vue.$log.debug('setSensorStatus')
      state.sensorStatus = status
    },
    setPortStatus (state, status) {
      Vue.$log.debug('setPortStatus')
      state.portStatus = status
    },
    setFecStatus (state, status) {
      Vue.$log.debug('setFesStatus')
      state.isFec = status
    }
  },
  actions: {
    async getProductByNoAuth (context) {
      Vue.$log.debug('actions getProductByNoAuth')
      return new Promise((resolve, reject) => {
        instance
          .get(`/api/about`, {
            header: {
              withCredentials: false
            }
          }).then(response => {
            Vue.$log.debug(`receive /api/about`)
            let data = response.data
            if (data.error_code === 200) {
              context.commit('setSysHostInfo', data.result)
              document.title = data.result.Hostname
              if (data.result.Product.includes('5216')) instance.defaults.timeout = 50000
              resolve(data)
            }
          })
          .catch(function (error) {
            reject(error)
          })
      })
    },
    async checkSwitchReboot (context) {
      Vue.$log.debug('actions checkSwitchReboot')
      return new Promise((resolve, reject) => {
        instance
          .get(`/api/live`, {
            header: {
              withCredentials: false
            }
          }).then(response => {
            Vue.$log.debug(`receive /api/live`)
            resolve(response)
          })
          .catch(function (error) {
            reject(error)
          })
      })
    },
    async auth (context, sid) {
      let tempSid = sid[0]
      Vue.$log.debug('actions auth')
      Vue.$log.debug(sid)
      return new Promise((resolve, reject) => {
        instance
          .get(`${PREFIX_URL}/users/verification`, {
            timeout: 5000,
            headers: { 'authorization': `Bearer ${tempSid}` }
          }).then(async response => {
            Vue.$log.debug(`receive ${PREFIX_URL}/users/verification`)
            Vue.$log.debug(response.data)
            let data = response.data
            let user = {}
            context.commit('updateTimeout')
            if (data.error_code === 200) {
              user.username = data.result['key']
              user.auth = tempSid
              user.authPassed = 1
              user.groupname = data.result['val']['Privilege']
              context.commit('setCurrentUser', { user: user })
              await context.dispatch('getLagInfo')
              context.dispatch('getFirmwareInfo')
              context.dispatch('getSysBoard')
              context.dispatch('getLagStatus')
              context.dispatch('getSystemSensorStatus')
              Vue.cookie.set(config.system.cookieSID, user.auth + '::' + sid[1])
              Vue.cookie.set(config.system.cookieLoginTime, new Date())
              resolve(user)
            } else {
              let error = { message: '' }
              error.message = 'authorized error'
              context.commit('logout')
              Vue.cookie.delete(config.system.cookieSID)
              Vue.cookie.delete(config.system.cookieLoginTime)
              reject(error)
            }
          })
          .catch(function (error) {
            reject(error)
          })
      })
    },
    async postLogin (context, { user }) {
      Vue.$log.debug('actions postLogin')
      Vue.$log.debug(user)
      user = {
        'username': user.username,
        'password': user.pwd
      }
      return new Promise((resolve, reject) => {
        instance
          .post(`${PREFIX_URL}/users/login`, user, {
            timeout: 5000,
            'headers': { 'Content-Type': 'application/json;charset=UTF-8' }
          }).then(async response => {
            Vue.$log.debug(`receive ${PREFIX_URL}/users/login`)
            Vue.$log.debug(response.data)
            context.commit('updateTimeout')
            let data = response.data
            if (data.error_code === 200) {
              // context.commit('login')
              user.auth = data.result
              user.authPassed = 1
              user.groupname = (user.username === 'admin' || user.username === 'root') ? 15 : 0
              context.commit('setCurrentUser', {user: user})
              Vue.cookie.set(config.system.cookieSID, user.auth + '::' + user.password)
              Vue.cookie.set(config.system.cookieLoginTime, new Date())
              await context.dispatch('getLagInfo')
              context.dispatch('getFirmwareInfo')
              context.dispatch('getSysBoard')
              context.dispatch('getLagStatus')
              context.dispatch('getSystemSensorStatus')
              resolve(user)
            } else {
              let error = { message: '' }
              error.message = Vue.t('login.authorizedError')
              context.commit('setCurrentUser', { user: null })
              context.commit('logout')
              Vue.cookie.delete(config.system.cookieSID)
              Vue.cookie.delete(config.system.cookieLoginTime)
              reject(error)
            }
          })
          .catch(error => {
            error.message = Vue.t('login.authorizedError')
            Vue.cookie.delete(config.system.cookieSID)
            reject(error)
          })
      })
    },
    reloadWin (context) {
      window.location.reload(true)
      Vue.$log.debug('reload window')
    },
    async postLogout (context) {
      Vue.$log.info('logout >>>')
      Vue.cookie.delete(config.system.cookieSID)
      Vue.cookie.delete(config.system.cookieLoginTime)
      await context.dispatch('reloadWin')
      context.commit('setCurrentUser', { user: null })
      context.commit('updateDataChanged', false)
      // context.commit('logout')
    },
    getUsersLogin (context) {
      Vue.$log.debug('actions getUsersLogin')
      return new Promise((resolve, reject) => {
        instance
          .get(`${PREFIX_URL}/users/login`, {
            headers: {
              'content-type': 'application/json',
              authorization: `Bearer ${state.currentUser.auth}`
            }
          }).then(response => {
            Vue.$log.debug(`receive ${PREFIX_URL}/users/login`)
            let data = response.data
            if (data.error_code === 200) {
              context.commit('renewAuth', data.result)
              Vue.cookie.set(config.system.cookieSID, data.result + '::' + state.currentUser.password)
              Vue.cookie.set(config.system.cookieLoginTime, new Date())
            }
            resolve(response)
          }).catch(error => {
            Vue.$log.error(error)
            reject(error)
          })
      })
    },
    getSystemTime (context) {
      Vue.$log.debug('actions getSystemTime')
      return new Promise((resolve, reject) => {
        instance
          .get(`${PREFIX_URL}/system/clock`, {
            headers: {
              'content-type': 'application/json',
              authorization: `Bearer ${state.currentUser.auth}`
            }
          }).then(response => {
            Vue.$log.debug(`receive ${PREFIX_URL}/system/clock`)
            context.commit('setTimeconfig', {
              key: 'time',
              val: response.data.result
            })
            resolve(response)
          }).catch(error => {
            if (!state.showFullLoading) {
              context.commit('updateFullLoadingStatus', true)
              context.commit('setUpdateStatus', false)
              context.commit('setLoadingType', 'restart')
            }
            Vue.$log.error(error)
            reject(error)
          })
      })
    },
    setSystemTime (context, time) {
      Vue.$log.debug('actions setSystemTime')
      return new Promise((resolve, reject) => {
        instance
          .put(`${PREFIX_URL}/system/clock`, time, {
            headers: {
              'content-type': 'application/json',
              authorization: `Bearer ${state.currentUser.auth}`
            }
          }).then(response => {
            Vue.$log.debug(`receive setSystemTime ${PREFIX_URL}/system/clock`)
            Vue.$log.debug(response)
            resolve(response)
          }).catch(error => {
            reject(error)
          })
      })
    },
    getTimezone (context) {
      Vue.$log.debug('actions getTimezone')
      return new Promise((resolve, reject) => {
        instance
          .get(`${PREFIX_URL}/sntp/timezone`, {
            headers: {
              'content-type': 'application/json',
              authorization: `Bearer ${state.currentUser.auth}`
            }
          }).then(response => {
            Vue.$log.debug(`receive ${PREFIX_URL}/sntp/timezone`)
            let tz = (response.data.result.timezone === '') ? '+00:00' : response.data.result.timezone
            context.commit('setTimeconfig', {
              key: 'timezone',
              val: tz
            })
            resolve(response)
          }).catch(error => {
            Vue.$log.error(error)
            reject(error)
          })
      })
    },
    setTimezone (context, timezone) {
      Vue.$log.debug('actions setTimezone')
      return new Promise((resolve, reject) => {
        instance
          .put(`${PREFIX_URL}/sntp/timezone`, {
            'timezone': timezone
          }, {
            headers: {
              'content-type': 'application/json',
              authorization: `Bearer ${state.currentUser.auth}`}
          }).then(response => {
            Vue.$log.debug(`receive setTimezone ${PREFIX_URL}/sntp/timezone`)
            Vue.$log.debug(response)
            resolve(response)
          }).catch(error => {
            reject(error)
          })
      })
    },
    getNtpStatus (context) {
      Vue.$log.debug('actions getNtpStatus')
      return new Promise((resolve, reject) => {
        instance
          .get(`${PREFIX_URL}/sntp/status`, {
            headers: {
              'content-type': 'application/json',
              authorization: `Bearer ${state.currentUser.auth}`
            }
          }).then(response => {
            Vue.$log.debug(`receive ${PREFIX_URL}/sntp/status`)
            resolve(response)
          }).catch(error => {
            Vue.$log.error(error)
            reject(error)
          })
      })
    },
    getNtpConfig (context) {
      Vue.$log.debug('actions getNtpConfig')
      return new Promise((resolve, reject) => {
        instance
          .get(`${PREFIX_URL}/sntp/server`, {
            headers: {
              'content-type': 'application/json',
              authorization: `Bearer ${state.currentUser.auth}`
            }
          }).then(response => {
            Vue.$log.debug(`receive ${PREFIX_URL}/sntp/server`)
            resolve(response)
          }).catch(error => {
            Vue.$log.error(error)
            reject(error)
          })
      })
    },
    addNtpConfig (context, status) {
      Vue.$log.debug('actions setNtpConfig')
      return new Promise((resolve, reject) => {
        instance
          .post(`${PREFIX_URL}/sntp/server`, {
            'idx': status.key,
            'data': status.val
          }, {
            headers: {
              'content-type': 'application/json',
              authorization: `Bearer ${state.currentUser.auth}`
            }
          }).then(response => {
            Vue.$log.debug(`receive setNtpConfig ${PREFIX_URL}/sntp/server`)
            Vue.$log.debug(response)
            resolve(response)
          }).catch(error => {
            reject(error)
          })
      })
    },
    setNtpConfig (context, status) {
      Vue.$log.debug('actions setNtpConfig')
      return new Promise((resolve, reject) => {
        instance
          .put(`${PREFIX_URL}/sntp/server`, {
            'idx': status.key,
            'data': status.val
          }, {
            headers: {
              'content-type': 'application/json',
              authorization: `Bearer ${state.currentUser.auth}`
            }
          }).then(response => {
            Vue.$log.debug(`receive setNtpConfig ${PREFIX_URL}/sntp/server`)
            Vue.$log.debug(response)
            resolve(response)
          }).catch(error => {
            reject(error)
          })
      })
    },
    delNtpConfig (context, index) {
      Vue.$log.debug('actions delNtpConfig')
      return new Promise((resolve, reject) => {
        instance
          .delete(`${PREFIX_URL}/sntp/server`, {
            headers: {
              'content-type': 'application/json',
              authorization: `Bearer ${state.currentUser.auth}`
            },
            data: {
              idx: index
            }
          }).then(response => {
            Vue.$log.debug(`receive delNtpConfig ${PREFIX_URL}/sntp/server`)
            Vue.$log.debug(response)
            resolve(response)
          }).catch(error => {
            reject(error)
          })
      })
    },
    getNtpAdminState (context) {
      Vue.$log.debug('actions getNtpAdminState')
      return new Promise((resolve, reject) => {
        instance
          .get(`${PREFIX_URL}/sntp`, {
            headers: {
              'content-type': 'application/json',
              authorization: `Bearer ${state.currentUser.auth}`
            }
          }).then(response => {
            Vue.$log.debug(`receive ${PREFIX_URL}/sntp`)
            context.commit('setTimeconfig', {
              key: 'isNTP',
              val: response.data.result.AdminState
            })
            resolve(response)
          }).catch(error => {
            Vue.$log.error(error)
            reject(error)
          })
      })
    },
    setNtpServerStatus (context, status) {
      return new Promise((resolve, reject) => {
        instance
          .put(`${PREFIX_URL}/sntp`, {
            'data': {
              'AdminState': status
            }
          }, {
            headers: {
              'content-type': 'application/json',
              authorization: `Bearer ${state.currentUser.auth}`
            }
          }).then(response => {
            Vue.$log.debug(`receive setNtpServerStatus ${PREFIX_URL}/sntp`)
            Vue.$log.debug(response)
            resolve(response)
          }).catch(error => {
            reject(error)
          })
      })
    },
    getSystemInfo (context) {
      Vue.$log.debug('actions getSystemInfo')
      return new Promise((resolve, reject) => {
        instance
          .get(`${PREFIX_URL}/system/info`, {
            headers: {
              'content-type': 'application/json',
              authorization: `Bearer ${state.currentUser.auth}`
            }
          }).then(response => {
            Vue.$log.debug(`receive ${PREFIX_URL}/system/info`)
            resolve(response)
          }).catch(error => {
            Vue.$log.debug(error)
            reject(error)
          })
      })
    },
    setSystemInfo (context, data) {
      Vue.$log.debug('action setSystemInfo')
      return new Promise((resolve, reject) => {
        instance
          .put(`${PREFIX_URL}/system/info`, data, {
            headers: {
              'content-type': 'application/json',
              authorization: `Bearer ${state.currentUser.auth}`
            }
          }).then(response => {
            Vue.$log.debug(`receive ${PREFIX_URL}/system/info`)
            resolve(response)
          }).catch(error => {
            Vue.$log.debug(error)
            reject(error)
          })
      })
    },
    getSystemSensorStatus (context) {
      Vue.$log.debug('actions getSystemSensorStatus')
      return new Promise((resolve, reject) => {
        instance
          .get(`${PREFIX_URL}/system/sensor`, {
            headers: {
              'content-type': 'application/json',
              authorization: `Bearer ${state.currentUser.auth}`
            }
          }).then(response => {
            Vue.$log.debug(`receive ${PREFIX_URL}/system/sensor`)
            context.commit('setSensorStatus', response.data.result)
            resolve(response)
          }).catch(error => {
            Vue.$log.debug(error)
            reject(error)
          })
      })
    },
    getSystemUptime (context) {
      Vue.$log.debug('actions getSystemUptime')
      return new Promise((resolve, reject) => {
        instance
          .get(`${PREFIX_URL}/system/time`, {
            headers: {
              'content-type': 'application/json',
              authorization: `Bearer ${state.currentUser.auth}`
            }
          }).then(response => {
            Vue.$log.debug(`receive ${PREFIX_URL}/system/times`)
            resolve(response)
          }).catch(error => {
            Vue.$log.debug(error)
            reject(error)
          })
      })
    },
    getFirmwareInfo (context) {
      Vue.$log.debug('actions getFirmwareInfo')
      return new Promise((resolve, reject) => {
        instance
          .get(`${PREFIX_URL}/firmware/info`, {headers: {
            'content-type': 'application/json',
            authorization: `Bearer ${state.currentUser.auth}`
          }}).then(response => {
            Vue.$log.debug(`receive ${PREFIX_URL}/firmware/info`)
            if (response.data.error_code === 200) {
              context.commit('updateFirmwareInfo', response.data.result)
              context.commit('setAboutInfo', {
                key: 'version',
                val: response.data.result.version + '.' + response.data.result.number
              })
              context.commit('setAboutInfo', {
                key: 'build',
                val: response.data.result.date
              })
            }
            resolve(response)
          }).catch(error => {
            Vue.$log.debug(error)
            reject(error)
          })
      })
    },
    getSysBoard (context) {
      Vue.$log.debug('actions getSysBoard')
      return new Promise((resolve, reject) => {
        instance
          .get(`${PREFIX_URL}/system/board`, {headers: {
            'content-type': 'application/json',
            authorization: `Bearer ${state.currentUser.auth}`
          }}).then(response => {
            Vue.$log.debug(`receive ${PREFIX_URL}/system/board`)
            if (response.data.error_code === 200) {
              context.commit('setAboutInfo', {
                key: 'model',
                val: response.data.result.Product
              })
              context.commit('setPortNumber', response.data.result.PortNum)
              context.commit('setSysBoard', response.data.result)
              // context.commit('setFecStatus', (response.data.result.Product.includes('M5216')))
            }
            resolve(response)
          }).catch(error => {
            Vue.$log.debug(error)
            reject(error)
          })
      })
    },
    getFWstatus (context) {
      Vue.$log.debug('actions getFWstatus')
      return new Promise((resolve, reject) => {
        instance
          .get(`${PREFIX_URL}/firmware/status`, {
            headers: {
              'content-type': 'application/json',
              authorization: `Bearer ${state.currentUser.auth}`
            },
            timeout: 5000
          }).then(response => {
            Vue.$log.debug(`receive ${PREFIX_URL}/firmware/status`)
            Vue.$log.debug(state.fwProgressStatus)
            let res = response.data.result
            switch (res.progress) {
              case 'none':
              case 'preparing':
              case 'extracting':
              case 'installing':
                break
              case 'failed':
                context.commit('setUpdateStatus', false)
                context.commit('setLoadingType', '')
                context.commit('setErrorWin', {
                  show: true,
                  data: res.message,
                  title: null
                })
                context.commit('setProgress', 0)
                break
              case 'done':
                context.commit('updateFullLoadingStatus', true)
                context.commit('setUpdateStatus', false)
                context.commit('setLoadingType', 'restart')
                break
              default:
                break
            }
            context.commit('setfwProgressStatus', response.data.result.progress)
            resolve(response)
          }).catch(error => {
            Vue.$log.debug(error)
            if (error.message && error.message.includes('timeout')) {
              context.commit('updateFullLoadingStatus', true)
              context.commit('setUpdateStatus', false)
              context.commit('setLoadingType', 'restart')
            } else if (error.response.status === 401) {
              context.commit('setUpdateStatus', false)
              context.commit('setLoadingType', '')
            } else {
              context.commit('setUpdateStatus', false)
              context.commit('setLoadingType', '')
              context.commit('setErrorWin', {
                show: true,
                data: error.response.data,
                title: null
              })
              context.commit('setProgress', 0)
            }
            reject(error)
          })
      })
    },
    getFWupdateStatus (context) {
      Vue.$log.debug('actions getFWupdateStatus')
      return new Promise((resolve, reject) => {
        instance
          .get(`${PREFIX_URL}/firmware/update`, {
            headers: {
              'content-type': 'application/json',
              authorization: `Bearer ${state.currentUser.auth}`
            },
            timeout: 5000
          }).then(response => {
            Vue.$log.debug(`receive ${PREFIX_URL}/firmware/update`)
            let res = response.data.result
            if (response.status === 200 && res) {
              resolve(res[res.length - 1])
            } else {
              resolve(response)
            }
          }).catch(error => {
            Vue.$log.debug(error)
            reject(error)
          })
      })
    },
    getFWcondition (contest) {
      Vue.$log.debug('actions getFWcondition')
      return new Promise((resolve, reject) => {
        instance
          .get(`${PREFIX_URL}/firmware/condition`, {headers: {
            'content-type': 'application/json',
            authorization: `Bearer ${state.currentUser.auth}`
          }}).then(response => {
            Vue.$log.debug(`receive ${PREFIX_URL}/firmware/condition`)
            resolve(response)
          }).catch(error => {
            Vue.$log.debug(error)
            reject(error)
          })
      })
    },
    checkLiveUpdate (context) {
      Vue.$log.debug('actions checkLiveUpdate')
      return new Promise((resolve, reject) => {
        instance
          .get(`${PREFIX_URL}/firmware/update/check`, {
            headers: {
              'content-type': 'application/json',
              authorization: `Bearer ${state.currentUser.auth}`
            }
          }).then(response => {
            Vue.$log.debug(`receive ${PREFIX_URL}/firmware/update/check`)
            resolve(response)
          }).catch(error => {
            Vue.$log.debug(error)
            reject(error)
          })
      })
    },
    postLocalChunkUpload (context, chunk) {
      Vue.$log.debug('actions postLocalChunkUpload')
      return new Promise((resolve, reject) => {
        instance
          .post(`${PREFIX_URL}/firmware/update/chunk`, chunk.data, {
            headers: {
              'content-type': 'application/octet-stream',
              authorization: `Bearer ${state.currentUser.auth}`,
              'Content-Range': `bytes ${chunk.start}-${chunk.loaded}/${chunk.filesize}`,
              'Content-Disposition': `attachment; filename="${chunk.filename}"`,
              'Session-ID': `${chunk.seesionid}`
            },
            timeout: 300000
          }).then(response => {
            Vue.$log.debug(`receive ${PREFIX_URL}/firmware/update/chunk`)
            Vue.$log.debug(response)
            resolve(response)
          }).catch(error => {
            reject(error)
          })
      })
    },
    postLocalUpload (context, file) {
      Vue.$log.debug('actions postLocalUpload')
      return new Promise((resolve, reject) => {
        instance
          .post(`${PREFIX_URL}/firmware/update/local`, file, {
            headers: {
              'content-type': 'multipart/form-data',
              authorization: `Bearer ${state.currentUser.auth}`
            },
            timeout: 300000
          }).then(response => {
            Vue.$log.debug(`receive ${PREFIX_URL}/firmware/update/local`)
            Vue.$log.debug(response)
            resolve(response)
          }).catch(error => {
            reject(error)
          })
      })
    },
    postLiveUpload (context) {
      Vue.$log.debug('actions postLiveUpload')
      return new Promise((resolve, reject) => {
        instance
          .post(`${PREFIX_URL}/firmware/update/live`, {}, {
            headers: {
              'content-type': 'application/json',
              authorization: `Bearer ${state.currentUser.auth}`
            }
          }).then(response => {
            Vue.$log.debug(`receive ${PREFIX_URL}/firmware/update/live`)
            resolve(response)
          }).catch(error => {
            reject(error)
          })
      })
    },
    getSystemConfig (context) {
      Vue.$log.debug('actions getSystemConfig')
      return new Promise((resolve, reject) => {
        instance
          .get(`${PREFIX_URL}/system/config`, {
            headers: {
              'content-type': 'application/octet-stream',
              authorization: `Bearer ${state.currentUser.auth}`
            },
            responseType: 'blob'
          }).then(response => {
            Vue.$log.debug(`receive ${PREFIX_URL}/system/config`)
            resolve(response)
          }).catch(error => {
            Vue.$log.debug(error)
            reject(error)
          })
      })
    },
    restoreSystemConfig (context, file) {
      Vue.$log.debug('actions restoreSystemConfig')
      return new Promise((resolve, reject) => {
        instance
          .post(`${PREFIX_URL}/system/config`, file, {
            headers: {
              'content-type': 'multipart/form-data',
              authorization: `Bearer ${state.currentUser.auth}`
            }
          }).then(response => {
            Vue.$log.debug(`receive ${PREFIX_URL}/system/config`, response)
            resolve(response)
          }).catch(error => {
            reject(error)
          })
      })
    },
    getSystemHttps (context) {
      Vue.$log.debug('actions getSystemHttps')
      return new Promise((resolve, reject) => {
        instance
          .get(`${PREFIX_URL}/system/https`, {
            headers: {
              'content-type': 'application/json',
              authorization: `Bearer ${state.currentUser.auth}`
            }
          }).then(response => {
            Vue.$log.debug(`receive ${PREFIX_URL}/system/https`)
            resolve(response)
          }).catch(error => {
            Vue.$log.debug(error)
            reject(error)
          })
      })
    },
    setSystemHttps (context, data) {
      Vue.$log.debug('action setSystemHttps')
      return new Promise((resolve, reject) => {
        instance
          .put(`${PREFIX_URL}/system/https`, data, {
            headers: {
              'content-type': 'application/json',
              authorization: `Bearer ${state.currentUser.auth}`
            }
          }).then(response => {
            Vue.$log.debug(`receive ${PREFIX_URL}/system/https`)
            resolve(response)
          }).catch(error => {
            Vue.$log.debug(error)
            reject(error)
          })
      })
    },
    setSwitchAction (context, status) {
      Vue.$log.debug('actions setSwitchAction')
      return new Promise((resolve, reject) => {
        instance
          .post(`${PREFIX_URL}/system/command`, {
            'command': status
          }, {
            headers: {
              'content-type': 'application/json',
              authorization: `Bearer ${state.currentUser.auth}`
            }
          }).then(response => {
            Vue.$log.debug(`post ${PREFIX_URL}/system/command`)
            resolve(response)
          }).catch(error => {
            Vue.$log.debug(error)
            reject(error)
          })
      })
    },
    setUserPassword (context, password) {
      Vue.$log.debug('actions setUserPassword')
      return new Promise((resolve, reject) => {
        instance
          .put(`${PREFIX_URL}/users`, {
            'idx': state.currentUser.username,
            'data': {
              'Password': password
            }
          }, {
            headers: {
              'content-type': 'application/json',
              authorization: `Bearer ${state.currentUser.auth}`
            }
          }).then(response => {
            Vue.$log.debug(`receive ${PREFIX_URL}/users`)
            resolve(response)
          }).catch(error => {
            reject(error)
          })
      })
    },
    getPortStatus (context) {
      Vue.$log.debug('actions getPortStatus')
      return new Promise((resolve, reject) => {
        instance
          .get(`${PREFIX_URL}/ports/status`, {
            headers: {
              'content-type': 'application/json',
              authorization: `Bearer ${state.currentUser.auth}`
            }
          }).then(response => {
            Vue.$log.debug(`receive ${PREFIX_URL}/ports/status`)
            resolve(response)
          }).catch(error => {
            reject(error)
          })
      })
    },
    getPortConfigure (context) {
      Vue.$log.debug('actions getPortConfigure')
      return new Promise((resolve, reject) => {
        instance
          .get(`${PREFIX_URL}/ports`, {
            headers: {
              'content-type': 'application/json',
              authorization: `Bearer ${state.currentUser.auth}`
            }
          }).then(response => {
            Vue.$log.debug('receive getPortConfigure')
            resolve(response)
          }).catch(error => {
            reject(error)
          })
      })
    },
    getFecConfigure (context) {
      Vue.$log.debug('actions getPortConfigure')
      return new Promise((resolve, reject) => {
        instance
          .get(`${PREFIX_URL}/ports/fec`, {
            headers: {
              'content-type': 'application/json',
              authorization: `Bearer ${state.currentUser.auth}`
            }
          }).then(response => {
            Vue.$log.debug('receive getFecConfigure')
            resolve(response)
          }).catch(error => {
            reject(error)
          })
      })
    },
    postPortConfigure (context, port) {
      Vue.$log.debug('actions postPortConfigure')
      return new Promise((resolve, reject) => {
        instance
          .put(`${PREFIX_URL}/portlist`,
            port
            , {
              headers: {
                'content-type': 'application/json',
                authorization: `Bearer ${state.currentUser.auth}`
              },
              timeout: 60000
            }).then(response => {
            Vue.$log.debug(`receive ${PREFIX_URL}/ports/config`)
            resolve(response)
          }).catch(error => {
            reject(error)
          })
      })
    },
    getPortStatistics (context) {
      Vue.$log.debug('actions getPortStatistics')
      return new Promise((resolve, reject) => {
        instance
          .get(`${PREFIX_URL}/ports/statistics`, {
            headers: {
              'content-type': 'application/json',
              authorization: `Bearer ${state.currentUser.auth}`
            }
          }).then(response => {
            Vue.$log.debug(`receive ${PREFIX_URL}/ports/statistics`)
            resolve(response)
          }).catch(error => {
            reject(error)
          })
      })
    },
    getPortStatisticsEthernet (context) {
      Vue.$log.debug('actions getPortStatisticsEthernet')
      return new Promise((resolve, reject) => {
        instance
          .get(`${PREFIX_URL}/ports/ethernet`, {
            headers: {
              'content-type': 'application/json',
              authorization: `Bearer ${state.currentUser.auth}`
            }
          }).then(response => {
            Vue.$log.debug(`receive ${PREFIX_URL}/ports/ethernet`)
            resolve(response)
          }).catch(error => {
            reject(error)
          })
      })
    },
    getPortResourcebyID (context, port) {
      Vue.$log.debug('actions getPortResourcebyID')
      return new Promise((resolve, reject) => {
        instance
          .get(`${PREFIX_URL}/ports/resource?key=${port}`, {
            headers: {
              'content-type': 'application/json',
              authorization: `Bearer ${state.currentUser.auth}`
            }
          }).then(response => {
            Vue.$log.debug(`receive ${PREFIX_URL}/ports/resource`)
            resolve(response)
          }).catch(error => {
            reject(error)
          })
      })
    },
    getPortResource (context) {
      Vue.$log.debug('actions getPortResource')
      return new Promise((resolve, reject) => {
        instance
          .get(`${PREFIX_URL}/ports/resource`, {
            headers: {
              'content-type': 'application/json',
              authorization: `Bearer ${state.currentUser.auth}`
            }
          }).then(response => {
            Vue.$log.debug(`receive ${PREFIX_URL}/ports/resource`)
            resolve(response)
          }).catch(error => {
            reject(error)
          })
      })
    },
    // TODO:
    getPortResourceUnit64 (context) {
      Vue.$log.debug('actions getPortResourceUnit64')
      return new Promise((resolve, reject) => {
        instance
          .get(`${PREFIX_URL}/ports/resource/uint64`, {
            headers: {
              'content-type': 'application/json',
              authorization: `Bearer ${state.currentUser.auth}`
            }
          }).then(response => {
            Vue.$log.debug(`receive ${PREFIX_URL}/ports/resource/uint64`)
            resolve(response)
          }).catch(error => {
            reject(error)
          })
      })
    },
    getPortGroup (context) {
      Vue.$log.debug('actions getPortGroup')
      return new Promise((resolve, reject) => {
        instance
          .get(`${PREFIX_URL}/ports/group`, {
            headers: {
              'content-type': 'application/json',
              authorization: `Bearer ${state.currentUser.auth}`
            }
          }).then(response => {
            Vue.$log.debug(`receive ${PREFIX_URL}/ports/group`)
            resolve(response)
          }).catch(error => {
            reject(error)
          })
      })
    },
    clearPortStatics (context, port) {
      Vue.$log.debug('actions clearPortStatics')
      return new Promise((resolve, reject) => {
        instance
          .post(`${PREFIX_URL}/ports/clear`, {}, {
            headers: {
              'content-type': 'application/json',
              authorization: `Bearer ${state.currentUser.auth}`
            }
          }).then(response => {
            Vue.$log.debug(`receive ${PREFIX_URL}/ports/clear`)
            resolve(response)
          }).catch(error => {
            reject(error)
          })
      })
    },
    getIP4Configure (context) {
      Vue.$log.debug('actions getIPConfigure')
      return new Promise((resolve, reject) => {
        instance
          .get(`${PREFIX_URL}/ip/ipv4/interface`, {
            headers: {
              'content-type': 'application/json',
              authorization: `Bearer ${state.currentUser.auth}`
            }
          }).then(response => {
            Vue.$log.debug(`receive ${PREFIX_URL}/ip/ipv4/interface`)
            resolve(response)
          }).catch(error => {
            Vue.$log.debug(error)
            reject(error)
          })
      })
    },
    getIP4Status (context) {
      Vue.$log.debug('actions getIP4Status')
      return new Promise((resolve, reject) => {
        instance
          .get(`${PREFIX_URL}/ip/ipv4/interface/status`, {
            headers: {
              'content-type': 'application/json',
              authorization: `Bearer ${state.currentUser.auth}`
            }
          }).then(response => {
            Vue.$log.debug(`receive ${PREFIX_URL}/ip/ipv4/interface`)
            resolve(response)
          }).catch(error => {
            Vue.$log.debug(error)
            reject(error)
          })
      })
    },
    getIP4ConfigRoute (context) {
      Vue.$log.debug('actions getIP4ConfigRoute')
      return new Promise((resolve, reject) => {
        instance
          .get(`${PREFIX_URL}/ip/ipv4/route`, {
            headers: {
              'content-type': 'application/json',
              authorization: `Bearer ${state.currentUser.auth}`
            }
          }).then(response => {
            Vue.$log.debug(`receive ${PREFIX_URL}/ip/ipv4/route`)
            resolve(response)
          }).catch(error => {
            Vue.$log.debug(error)
            reject(error)
          })
      })
    },
    getDNSConfig (context) {
      Vue.$log.debug('actions getDNSConfig')
      return new Promise((resolve, reject) => {
        instance
          .get(`${PREFIX_URL}/dns/server`, {
            headers: {
              'content-type': 'application/json',
              authorization: `Bearer ${state.currentUser.auth}`
            }
          }).then(response => {
            Vue.$log.debug('receive getDNSConfig')
            resolve(response)
          }).catch(error => {
            Vue.$log.debug(error)
            reject(error)
          })
      })
    },
    getIP4StatusRoute (context) {
      Vue.$log.debug('actions getIP4StatusRoute')
      return new Promise((resolve, reject) => {
        instance
          .get(`${PREFIX_URL}/ip/ipv4/route/status`, {
            headers: {
              'content-type': 'application/json',
              authorization: `Bearer ${state.currentUser.auth}`
            }
          }).then(response => {
            Vue.$log.debug(`receive ${PREFIX_URL}/ip/ipv4/route/status`)
            resolve(response)
          }).catch(error => {
            Vue.$log.debug(error)
            reject(error)
          })
      })
    },
    addDNS (context, dns) {
      Vue.$log.debug('addDNS:', dns)
      return new Promise((resolve, reject) => {
        instance
          .post(`${PREFIX_URL}/dns/server`, {
            'idx': '1',
            'data': {
              'IpAddress': dns
            }
          }, {
            headers: {
              'content-type': 'application/json',
              authorization: `Bearer ${state.currentUser.auth}`
            }
          }).then((response) => {
            Vue.$log.debug('addDNS success.', response)
            resolve(response.data)
          }).catch((error) => {
            Vue.$log.debug(error)
            reject(error)
          })
      })
    },
    setDNS (context, dns) {
      Vue.$log.debug('setDNS:', dns)
      return new Promise((resolve, reject) => {
        instance
          .put(`${PREFIX_URL}/dns/server`, {
            'idx': dns.key,
            'data': {
              'IpAddress': dns.val
            }
          }, {
            headers: {
              'content-type': 'application/json',
              authorization: `Bearer ${state.currentUser.auth}`
            }
          }).then((response) => {
            Vue.$log.debug('setDNS success.', response)
            resolve(response.data)
          }).catch((error) => {
            Vue.$log.debug(error)
            reject(error)
          })
      })
    },
    delDNS (context, key) {
      Vue.$log.debug('action delDNS')
      return new Promise((resolve, reject) => {
        instance
          .delete(`${PREFIX_URL}/dns/server`, {
            headers: {
              'content-type': 'application/json',
              authorization: `Bearer ${state.currentUser.auth}`
            },
            data: {
              idx: [key]
            }
          }, {
            headers: {
              'content-type': 'application/json',
              authorization: `Bearer ${state.currentUser.auth}`
            }
          }).then((response) => {
            Vue.$log.debug('delDNS success.', response)
            resolve(response.data)
          }).catch((error) => {
            Vue.$log.debug(error)
            reject(error)
          })
      })
    },
    setStatic (context, ipconfig) {
      Vue.$log.debug('action setStatic')
      let dns = (ipconfig.dns === '') ? [] : [ipconfig.dns]
      return new Promise((resolve, reject) => {
        instance
          .put(`${PREFIX_URL}/ip/ipv4/config`, {
            'data': {
              'enableDhcpClient': false,
              'dnsAddress': dns,
              'ipv4Address': ipconfig.config.ipv4Address,
              'subnetMask': ipconfig.config.subnetMask,
              'networkPrefixAddress': '0.0.0.0',
              'networkPrefixSize': 0,
              'nextHop': ipconfig.config.nextHop,
              'distance': 1
            },
            'idx': '1'
          },
          {
            headers: {
              'content-type': 'application/json',
              authorization: `Bearer ${state.currentUser.auth}`
            }
          }).then((response) => {
            Vue.$log.debug('setStatic success.', response)
            resolve(response.data)
          }).catch((error) => {
            Vue.$log.debug(error)
            reject(error)
          })
      })
    },
    addRoute (context, route) {
      Vue.$log.debug('addRoute:', route)
      return new Promise((resolve, reject) => {
        instance
          .post(`${PREFIX_URL}/ip/ipv4/route`, {
            'idx': {
              'networkAddress': '0.0.0.0',
              'networkPrefixSize': 0,
              'nextHop': route
            },
            'data': {
              'vlanID': '1',
              'distance': 1
            }
          }, {
            headers: {
              'content-type': 'application/json',
              authorization: `Bearer ${state.currentUser.auth}`
            }
          }).then((response) => {
            Vue.$log.debug('addRoute success.', response)
            resolve(response.data)
          }).catch((error) => {
            Vue.$log.debug(error)
            reject(error)
          })
      })
    },
    setRoute (context, route) {
      Vue.$log.debug('setRoute:', route)
      return new Promise((resolve, reject) => {
        instance
          .put(`${PREFIX_URL}/ip/ipv4/route`, {
            'idx': {
              'networkAddress': '0.0.0.0',
              'networkPrefixSize': 0,
              'nextHop': route
            },
            'data': {
              'vlanID': '1',
              'distance': 1
            }
          }, {
            headers: {
              'content-type': 'application/json',
              authorization: `Bearer ${state.currentUser.auth}`
            }
          }).then((response) => {
            Vue.$log.debug('setRoute success.', response)
            resolve(response.data)
          }).catch((error) => {
            Vue.$log.debug(error)
            reject(error)
          })
      })
    },
    delRoute (context, route) {
      Vue.$log.debug('delRoute:', route)
      return new Promise((resolve, reject) => {
        instance
          .delete(`${PREFIX_URL}/ip/ipv4/route`, {
            headers: {
              'content-type': 'application/json',
              authorization: `Bearer ${state.currentUser.auth}`
            },
            data: {
              idx: {
                networkAddress: '0.0.0.0',
                networkPrefixSize: 0,
                nextHop: route
              }
            }
          }, {
            headers: {
              'content-type': 'application/json',
              authorization: `Bearer ${state.currentUser.auth}`
            }
          }).then((response) => {
            Vue.$log.debug('delRoute success.', response)
            resolve(response.data)
          }).catch((error) => {
            Vue.$log.debug(error)
            reject(error)
          })
      })
    },
    setDHCPIp (context, ipconfig) {
      Vue.$log.debug('action setDHCP')
      return new Promise((resolve, reject) => {
        instance
          .put(`${PREFIX_URL}/ip/ipv4/config`, {
            'data': {
              'enableDhcpClient': true,
              'dnsAddress': [],
              'ipv4Address': '0.0.0.0',
              'subnetMask': '0.0.0.0',
              'networkPrefixAddress': '0.0.0.0',
              'networkPrefixSize': 0,
              'nextHop': '0.0.0.0',
              'distance': 1
            },
            'idx': '1'
          },
          {
            headers: {
              'content-type': 'application/json',
              authorization: `Bearer ${state.currentUser.auth}`
            }
          }).then((response) => {
            Vue.$log.debug('setDHCP success.', response)
            resolve(response.data)
          }).catch((error) => {
            Vue.$log.debug(error)
            reject(error)
          })
      })
    },
    setIP4MixPort (context, ipconfig) {
      Vue.$log.debug('action setIP4MixPort')
      let data = []
      let isVlan = false
      let isOob = false
      if (ipconfig.managementMode === 'vlan1') {
        isVlan = true
      } else {
        isOob = true
      }
      if (ipconfig.vlanPort.length > 0) {
        let vlanPortConfig = JSON.parse(JSON.stringify(ipconfig.vlanPort[0]))
        vlanPortConfig.dns = (vlanPortConfig.dns === '') ? [] : [vlanPortConfig.dns]
        if (vlanPortConfig.enableDhcpClient) {
          vlanPortConfig.dns = []
          vlanPortConfig.ipv4Address = ''
          vlanPortConfig.subnetMask = ''
          vlanPortConfig.nextHop = ''
        }
        let vlanPortData = {
          'data': {
            'enableInterface': isVlan,
            'enableDhcpClient': vlanPortConfig.enableDhcpClient,
            'dnsAddress': vlanPortConfig.dns,
            'ipv4Address': vlanPortConfig.ipv4Address,
            'subnetMask': vlanPortConfig.subnetMask,
            'networkPrefixAddress': '0.0.0.0',
            'networkPrefixSize': 0,
            'nextHop': vlanPortConfig.nextHop,
            'distance': 1
          },
          'idx': '1'
        }
        data.push(vlanPortData)
      } else {
        let vlanPortData = {
          'data': {
            'enableInterface': isVlan,
            'enableDhcpClient': false,
            'dnsAddress': [],
            'ipv4Address': '',
            'subnetMask': '',
            'nextHop': '',
            'networkPrefixAddress': '0.0.0.0',
            'networkPrefixSize': 0,
            'distance': 1
          },
          'idx': '1'
        }
        data.push(vlanPortData)
      }
      let oobPortConfig = JSON.parse(JSON.stringify(ipconfig.oobPort[0]))
      if (ipconfig.oobPort.length > 0) {
        oobPortConfig.dns = (oobPortConfig.dns === '') ? [] : [oobPortConfig.dns]
        if (oobPortConfig.enableDhcpClient) {
          oobPortConfig.dns = []
          oobPortConfig.ipv4Address = ''
          oobPortConfig.subnetMask = ''
          oobPortConfig.nextHop = ''
        }
        let oobPortData = {
          'data': {
            'enableInterface': isOob,
            'enableDhcpClient': oobPortConfig.enableDhcpClient,
            'dnsAddress': oobPortConfig.dns,
            'ipv4Address': oobPortConfig.ipv4Address,
            'subnetMask': oobPortConfig.subnetMask,
            'nextHop': oobPortConfig.nextHop,
            'networkPrefixAddress': '0.0.0.0',
            'networkPrefixSize': 0,
            'distance': 1
          },
          'idx': oobPortConfig.idx
        }
        data.push(oobPortData)
      } else {
        let oobPortData = {
          'data': {
            'enableInterface': isOob,
            'enableDhcpClient': false,
            'dnsAddress': [],
            'ipv4Address': '',
            'subnetMask': '',
            'nextHop': '',
            'networkPrefixAddress': '0.0.0.0',
            'networkPrefixSize': 0,
            'distance': 1
          },
          'idx': oobPortConfig.idx
        }
        data.push(oobPortData)
      }
      return new Promise((resolve, reject) => {
        instance
          .put(`${PREFIX_URL}/ip/ipv4/config/list`, data,
            {
              headers: {
                'content-type': 'application/json',
                authorization: `Bearer ${state.currentUser.auth}`
              }
            }).then((response) => {
            Vue.$log.debug('setIP4MixPort success.', response)
            resolve(response.data)
          }).catch((error) => {
            Vue.$log.debug(error)
            reject(error)
          })
      })
    },
    getOobIP4Interface (context) {
      Vue.$log.debug('actions getOobIP4Interface')
      return new Promise((resolve, reject) => {
        instance
          .get(`${PREFIX_URL}/ip/oob/ipv4/interface`, {
            headers: {
              'content-type': 'application/json',
              authorization: `Bearer ${state.currentUser.auth}`
            }
          }).then(response => {
            Vue.$log.debug(`receive ${PREFIX_URL}/ip/oob/ipv4/interface`)
            resolve(response)
          }).catch(error => {
            Vue.$log.debug(error)
            reject(error)
          })
      })
    },
    getOobIP4Configure (context) {
      Vue.$log.debug('actions getOobIP4Configure')
      return new Promise((resolve, reject) => {
        instance
          .get(`${PREFIX_URL}/ip/oob/ipv4/config`, {
            headers: {
              'content-type': 'application/json',
              authorization: `Bearer ${state.currentUser.auth}`
            }
          }).then(response => {
            Vue.$log.debug(`receive ${PREFIX_URL}/ip/oob/ipv4/config`)
            resolve(response)
          }).catch(error => {
            Vue.$log.debug(error)
            reject(error)
          })
      })
    },
    getOobIP4Status (context) {
      Vue.$log.debug('actions getOobIP4Status')
      return new Promise((resolve, reject) => {
        instance
          .get(`${PREFIX_URL}/ip/oob/ipv4/status`, {
            headers: {
              'content-type': 'application/json',
              authorization: `Bearer ${state.currentUser.auth}`
            }
          }).then(response => {
            Vue.$log.debug(`receive ${PREFIX_URL}/ip/oob/ipv4/status`)
            resolve(response)
          }).catch(error => {
            Vue.$log.debug(error)
            reject(error)
          })
      })
    },
    setOobIP4Configure (context, ipconfig) {
      Vue.$log.debug('action setOobIP4Configure')
      let config = JSON.parse(JSON.stringify(ipconfig.config))
      config.dns = (config.dns === '') ? [] : [config.dns]
      if (config.enableDhcpClient) {
        config.dns = []
        config.ipv4Address = ''
        config.subnetMask = ''
        config.nextHop = ''
      }
      Vue.$log.debug(config.dns)
      return new Promise((resolve, reject) => {
        instance
          .put(`${PREFIX_URL}/ip/oob/ipv4/config`, {
            'data': {
              'enableDhcpClient': config.enableDhcpClient,
              'dnsAddress': config.dns,
              'ipv4Address': config.ipv4Address,
              'subnetMask': config.subnetMask,
              'nextHop': config.nextHop
            },
            'idx': '1'
          },
          {
            headers: {
              'content-type': 'application/json',
              authorization: `Bearer ${state.currentUser.auth}`
            }
          }).then((response) => {
            Vue.$log.debug('setOobIP4Configure success.', response)
            resolve(response.data)
          }).catch((error) => {
            Vue.$log.debug(error)
            reject(error)
          })
      })
    },
    // VLAN setting
    getVlan (context) {
      Vue.$log.debug('actions getVlan')
      return new Promise((resolve, reject) => {
        instance
          .get(`${PREFIX_URL}/vlan`, {
            headers: {
              'content-type': 'application/json',
              authorization: `Bearer ${state.currentUser.auth}`
            }
          }).then(response => {
            Vue.$log.debug(`get ${PREFIX_URL}/vlan`)
            resolve(response)
          }).catch(error => {
            Vue.$log.debug(error)
            reject(error)
          })
      })
    },
    getVlanById (context, id) {
      Vue.$log.debug('actions getVlanById')
      return new Promise((resolve, reject) => {
        instance
          .get(`${PREFIX_URL}/vlan?key=${id}`, {
            headers: {
              'content-type': 'application/json',
              authorization: `Bearer ${state.currentUser.auth}`
            }
          }).then(response => {
            Vue.$log.debug(`get ${PREFIX_URL}/vlan?key=${id}`)
            resolve(response)
          }).catch(error => {
            Vue.$log.debug(error)
            reject(error)
          })
      })
    },
    delVlan (context, data) {
      Vue.$log.debug('actions delVlan')
      Vue.$log.debug(data)
      return new Promise((resolve, reject) => {
        instance
          .delete(`${PREFIX_URL}/vlan`, {
            headers: {
              'content-type': 'application/json',
              authorization: `Bearer ${state.currentUser.auth}`
            },
            data: {
              idx: data
            }
          }).then(response => {
            Vue.$log.debug(`delete ${PREFIX_URL}/vlan`)
            resolve(response)
          }).catch(error => {
            Vue.$log.debug(error)
            reject(error)
          })
      })
    },
    setVlan (context, params) {
      Vue.$log.debug('actions setVlan:', params.data)
      if (params.action === 'add') {
        return new Promise((resolve, reject) => {
          instance
            .post(`${PREFIX_URL}/vlan`, {
              'data': params.data
            }, {
              headers: {
                'content-type': 'application/json',
                authorization: `Bearer ${state.currentUser.auth}`
              }
            }).then(response => {
              Vue.$log.debug(`post ${PREFIX_URL}/vlan`)
              resolve(response)
            }).catch(error => {
              Vue.$log.debug(error)
              reject(error)
            })
        })
      } else {
        return new Promise((resolve, reject) => {
          instance
            .put(`${PREFIX_URL}/vlan`, {
              'data': params.data
            }, {
              headers: {
                'content-type': 'application/json',
                authorization: `Bearer ${state.currentUser.auth}`
              }
            }).then(response => {
              Vue.$log.debug(`post ${PREFIX_URL}/vlan`)
              resolve(response)
            }).catch(error => {
              Vue.$log.debug(error)
              reject(error)
            })
        })
      }
    },
    getVlanIdx (context) {
      Vue.$log.debug('actions getVlanIdx')
      return new Promise((resolve, reject) => {
        instance
          .get(`${PREFIX_URL}/vlan/indexs`, {
            headers: {
              'content-type': 'application/json',
              authorization: `Bearer ${state.currentUser.auth}`
            }
          }).then(response => {
            Vue.$log.debug(`get ${PREFIX_URL}/vlan/indexs`)
            resolve(response)
          }).catch(error => {
            Vue.$log.debug(error)
            reject(error)
          })
      })
    },
    // LAG
    getLagStatus (context) {
      Vue.$log.debug('actions getLagStatus')
      return new Promise((resolve, reject) => {
        instance
          .get(`${PREFIX_URL}/lacp/group`, {
            headers: {
              'content-type': 'application/json',
              authorization: `Bearer ${state.currentUser.auth}`
            }
          }).then(response => {
            Vue.$log.debug(`receive ${PREFIX_URL}/lacp/group`)
            state.lagGroupMap = new Map()
            state.portMap = new Map()
            let data = response.data.result
            if (data.length > 0) {
              data.forEach(element => {
                state.lagGroupMap.set(Number(element.key) + state.lagStartNum, element.val.PortMembers)
                element.val.PortMembers.forEach(port => {
                  state.portMap.set(Number(port), Number(element.key) + state.lagStartNum)
                })
              })
            }
            resolve(response)
          }).catch(error => {
            Vue.$log.debug(error)
            reject(error)
          })
      })
    },
    addLagStatus (context, status) {
      Vue.$log.debug('addLagStatus, status: ', status)
      return new Promise((resolve, reject) => {
        instance
          .post(`${PREFIX_URL}/lacp/group`, {
            'idx': status.key,
            'data': status.val
          }, {
            headers: {
              'content-type': 'application/json',
              authorization: `Bearer ${state.currentUser.auth}`
            }
          }).then(response => {
            Vue.$log.debug(`receive ${PREFIX_URL}/lacp/group`)
            resolve(response)
          }).catch(error => {
            Vue.$log.debug(error)
            reject(error)
          })
      })
    },
    setLagStatus (context, status) {
      Vue.$log.debug('setLagStatus, status: ' + status)
      return new Promise((resolve, reject) => {
        instance
          .put(`${PREFIX_URL}/lacp/group`, {
            'idx': status.key,
            'data': status.val
          }, {
            headers: {
              'content-type': 'application/json',
              authorization: `Bearer ${state.currentUser.auth}`
            }
          }).then(response => {
            Vue.$log.debug(`receive ${PREFIX_URL}/lacp/group`)
            resolve(response)
          }).catch(error => {
            Vue.$log.debug(error)
            reject(error)
          })
      })
    },
    delLagStatus (context, status) {
      Vue.$log.debug('delLagStatus, status: ', status)
      return new Promise((resolve, reject) => {
        instance
          .delete(`${PREFIX_URL}/lacp/group`, {
            headers: {
              'content-type': 'application/json',
              authorization: `Bearer ${state.currentUser.auth}`
            },
            data: {
              idx: [status.key]
            }
          }).then(response => {
            Vue.$log.debug(`receive ${PREFIX_URL}/lacp/group`)
            resolve(response)
          }).catch(error => {
            Vue.$log.debug(error)
            reject(error)
          })
      })
    },
    getLagInfo (context) {
      Vue.$log.debug('actions getLagInfo')
      return new Promise((resolve, reject) => {
        instance
          .get(`${PREFIX_URL}/lacp/info`, {
            headers: {
              'content-type': 'application/json',
              authorization: `Bearer ${state.currentUser.auth}`
            }
          }).then(response => {
            Vue.$log.debug(`receive ${PREFIX_URL}/lacp/info`)
            context.commit('setLagStartNumber', response.data.result)
            resolve(response)
          }).catch(error => {
            Vue.$log.debug(error)
            reject(error)
          })
      })
    },
    getAclPort (context) {
      Vue.$log.debug('actions getAclPort')
      return new Promise((resolve, reject) => {
        instance
          .get(`${PREFIX_URL}/acl/ports`, {
            headers: {
              'content-type': 'application/json',
              authorization: `Bearer ${state.currentUser.auth}`
            }
          }).then(response => {
            Vue.$log.debug(`receive ${PREFIX_URL}/acl/ports`)
            resolve(response)
          }).catch(error => {
            Vue.$log.debug(error)
            reject(error)
          })
      })
    },
    // Mac address table setting
    getMacTime (context) {
      Vue.$log.debug('actions getMacTime')
      return new Promise((resolve, reject) => {
        instance
          .get(`${PREFIX_URL}/mac`, {
            headers: {
              'content-type': 'application/json',
              authorization: `Bearer ${state.currentUser.auth}`
            }
          }).then(response => {
            Vue.$log.debug(`receive ${PREFIX_URL}/mac`)
            resolve(response)
          }).catch(error => {
            Vue.$log.debug(error)
            reject(error)
          })
      })
    },
    setMacTime (context, status) {
      Vue.$log.debug('actions setMacTime')
      return new Promise((resolve, reject) => {
        instance
          .put(`${PREFIX_URL}/mac`, {data: status}, {
            headers: {
              'content-type': 'application/json',
              authorization: `Bearer ${state.currentUser.auth}`
            }
          }).then(response => {
            Vue.$log.debug('receive setMacTime')
            resolve(response)
          }).catch(error => {
            Vue.$log.debug(error)
            reject(error)
          })
      })
    },
    getMacList (context) {
      Vue.$log.debug('actions getMacList')
      return new Promise((resolve, reject) => {
        instance
          .get(`${PREFIX_URL}/mac/fdb/status`, {
            headers: {
              'content-type': 'application/json',
              authorization: `Bearer ${state.currentUser.auth}`
            }
          }).then(response => {
            Vue.$log.debug(`receive ${PREFIX_URL}/mac/fdb/status`)
            resolve(response)
          }).catch(error => {
            Vue.$log.debug(error)
            reject(error)
          })
      })
    },
    addStaticMac (context, status) {
      Vue.$log.debug('actions addStaticMac')
      return new Promise((resolve, reject) => {
        instance
          .post(`${PREFIX_URL}/mac/fdb`, status, {
            headers: {
              'content-type': 'application/json',
              authorization: `Bearer ${state.currentUser.auth}`
            }
          }).then(response => {
            Vue.$log.debug('receive addStaticMac')
            resolve(response)
          }).catch(error => {
            Vue.$log.debug(error)
            reject(error)
          })
      })
    },
    setStaticMac (context, status) {
      Vue.$log.debug('actions setStaticMac')
      return new Promise((resolve, reject) => {
        instance
          .put(`${PREFIX_URL}/mac/fdb`, status, {
            headers: {
              'content-type': 'application/json',
              authorization: `Bearer ${state.currentUser.auth}`
            }
          }).then(response => {
            Vue.$log.debug('receive setStaticMac')
            resolve(response)
          }).catch(error => {
            Vue.$log.debug(error)
            reject(error)
          })
      })
    },
    delStaticMac (context, data) {
      Vue.$log.debug('actions delStaticMac')
      return new Promise((resolve, reject) => {
        instance
          .delete(`${PREFIX_URL}/mac/fdb`, {
            headers: {
              'content-type': 'application/json',
              authorization: `Bearer ${state.currentUser.auth}`
            },
            data: {
              idx: data
            }
          }).then(response => {
            Vue.$log.debug(`receive ${PREFIX_URL}/mac/fdb`)
            resolve(response)
          }).catch(error => {
            Vue.$log.debug(error)
            Vue.$log.debug(error.config)
            reject(error)
          })
      })
    },
    // TODO: Rate limit
    getIngressRate (context) {
      Vue.$log.debug('actions getIngressRate')
      return new Promise((resolve, reject) => {
        instance
          .post(PREFIX_URL, {
            'method': config.api.GET_QOS_CONFIG_INTERFACE_POLICER,
            'params': [],
            'id': getid()
          }, {
            headers: {
              'content-type': 'application/json',
              authorization: `Bearer ${state.currentUser.auth}`
            }
          }).then(response => {
            Vue.$log.debug('receive getIngressRate')
            resolve(response)
          }).catch(error => {
            Vue.$log.debug(error)
            reject(error)
          })
      })
    },
    getEgressRate (context) {
      Vue.$log.debug('actions getEgressRate')
      return new Promise((resolve, reject) => {
        instance
          .post(PREFIX_URL, {
            'method': config.api.GET_QOS_CONFIG_INTERFACE_SHAPER,
            'params': [],
            'id': getid()
          }, {
            headers: {
              'content-type': 'application/json',
              authorization: `Bearer ${state.currentUser.auth}`
            }
          }).then(response => {
            Vue.$log.debug('receive getEgressRate')
            resolve(response)
          }).catch(error => {
            Vue.$log.debug(error)
            reject(error)
          })
      })
    },
    setIngressRate (context, status) {
      Vue.$log.debug('actions setIngressRate')
      return new Promise((resolve, reject) => {
        instance
          .post(PREFIX_URL, {
            'method': config.api.SET_QOS_CONFIG_INTERFACE_POLICER,
            'params': [status.key, status.val],
            'id': getid()
          }, {
            headers: {
              'content-type': 'application/json',
              authorization: `Bearer ${state.currentUser.auth}`
            }
          }).then(response => {
            Vue.$log.debug('receive setIngressRate')
            resolve(response)
          }).catch(error => {
            Vue.$log.debug(error)
            reject(error)
          })
      })
    },
    setEgressRate (context, status) {
      Vue.$log.debug('actions setEgressRate')
      return new Promise((resolve, reject) => {
        instance
          .post(PREFIX_URL, {
            'method': config.api.SET_QOS_CONFIG_INTERFACE_SHAPER,
            'params': [status.key, status.val],
            'id': getid()
          }, {
            headers: {
              'content-type': 'application/json',
              authorization: `Bearer ${state.currentUser.auth}`
            }
          }).then(response => {
            Vue.$log.debug('receive setEgressRate')
            resolve(response)
          }).catch(error => {
            Vue.$log.debug(error)
            reject(error)
          })
      })
    },
    // ACL
    getIPacl (context) {
      Vue.$log.debug('actions getIPacl')
      return new Promise((resolve, reject) => {
        instance
          .get(`${PREFIX_URL}/acl/ip`, {
            headers: {
              'content-type': 'application/json',
              authorization: `Bearer ${state.currentUser.auth}`
            }
          }).then(response => {
            Vue.$log.debug(`receive ${PREFIX_URL}/acl/ip`)
            resolve(response)
          }).catch(error => {
            reject(error)
          })
      })
    },
    getMACacl (context) {
      Vue.$log.debug('actions getMACacl')
      return new Promise((resolve, reject) => {
        instance
          .get(`${PREFIX_URL}/acl/mac`, {
            headers: {
              'content-type': 'application/json',
              authorization: `Bearer ${state.currentUser.auth}`
            }
          }).then(response => {
            Vue.$log.debug(`receive ${PREFIX_URL}/acl/mac`)
            resolve(response)
          }).catch(error => {
            reject(error)
          })
      })
    },
    setIPacl (context, status) {
      Vue.$log.debug('setIPacl, status: ', status)
      return new Promise((resolve, reject) => {
        instance
          .put(`${PREFIX_URL}/acl/ip`, {
            'idx': status.idx,
            'data': status.val
          }, {
            headers: {
              'content-type': 'application/json',
              authorization: `Bearer ${state.currentUser.auth}`
            }
          }).then(response => {
            Vue.$log.debug(`receive ${PREFIX_URL}/acl/ip`)
            resolve(response)
          }).catch(error => {
            Vue.$log.debug(error)
            reject(error)
          })
      })
    },
    setMACacl (context, status) {
      Vue.$log.debug('setMACacl, status: ' + status)
      return new Promise((resolve, reject) => {
        instance
          .put(`${PREFIX_URL}/acl/mac`, {
            'idx': status.idx,
            'data': status.val
          }, {
            headers: {
              'content-type': 'application/json',
              authorization: `Bearer ${state.currentUser.auth}`
            }
          }).then(response => {
            Vue.$log.debug(`receive ${PREFIX_URL}/acl/mac`)
            resolve(response)
          }).catch(error => {
            Vue.$log.debug(error)
            reject(error)
          })
      })
    },
    addIPacl (context, status) {
      Vue.$log.debug('addIPacl, status: ', status)
      return new Promise((resolve, reject) => {
        instance
          .post(`${PREFIX_URL}/acl/ip`, {
            'idx': status.idx,
            'data': status.val
          }, {
            headers: {
              'content-type': 'application/json',
              authorization: `Bearer ${state.currentUser.auth}`
            }
          }).then(response => {
            Vue.$log.debug(`receive ${PREFIX_URL}/acl/ip`)
            resolve(response)
          }).catch(error => {
            Vue.$log.debug(error)
            reject(error)
          })
      })
    },
    addMACacl (context, status) {
      Vue.$log.debug('addMACacl, status: ' + status)
      return new Promise((resolve, reject) => {
        instance
          .post(`${PREFIX_URL}/acl/mac`, {
            'idx': status.idx,
            'data': status.val
          }, {
            headers: {
              'content-type': 'application/json',
              authorization: `Bearer ${state.currentUser.auth}`
            }
          }).then(response => {
            Vue.$log.debug(`receive ${PREFIX_URL}/acl/ip`)
            resolve(response)
          }).catch(error => {
            Vue.$log.debug(error)
            reject(error)
          })
      })
    },
    delIPacl (context, status) {
      Vue.$log.debug('delIPacl, status: ', status)
      return new Promise((resolve, reject) => {
        instance
          .delete(`${PREFIX_URL}/acl/ip`, {
            headers: {
              'content-type': 'application/json',
              authorization: `Bearer ${state.currentUser.auth}`
            },
            data: {
              idx: [status]
            }
          }).then(response => {
            Vue.$log.debug(`receive ${PREFIX_URL}/acl/ip`)
            resolve(response)
          }).catch(error => {
            Vue.$log.debug(error)
            reject(error)
          })
      })
    },
    delMACacl (context, status) {
      Vue.$log.debug('delMACacl, status: ' + status)
      return new Promise((resolve, reject) => {
        instance
          .delete(`${PREFIX_URL}/acl/mac`, {
            headers: {
              'content-type': 'application/json',
              authorization: `Bearer ${state.currentUser.auth}`
            },
            data: {
              idx: [status]
            }
          }).then(response => {
            Vue.$log.debug(`receive ${PREFIX_URL}/acl/mac`)
            resolve(response)
          }).catch(error => {
            Vue.$log.debug(error)
            reject(error)
          })
      })
    },
    // IGMP
    getIGMPSnooping (context) {
      Vue.$log.debug('actions getIGMPSnooping')
      return new Promise((resolve, reject) => {
        instance
          .get(`${PREFIX_URL}/igmp`, {
            headers: {
              'content-type': 'application/json',
              authorization: `Bearer ${state.currentUser.auth}`
            }
          }).then(response => {
            Vue.$log.debug(`receive ${PREFIX_URL}/igmp`)
            let res = response.data
            resolve(res)
          }).catch(error => {
            Vue.$log.debug(error)
            reject(error)
          })
      })
    },
    setIGMPSnooping (context, status) {
      Vue.$log.debug('actions setIGMPSnooping')
      return new Promise((resolve, reject) => {
        instance
          .put(`${PREFIX_URL}/igmp`, {data: status}, {
            headers: {
              'content-type': 'application/json',
              authorization: `Bearer ${state.currentUser.auth}`
            }
          }).then(response => {
            Vue.$log.debug('receive setIGMPSnooping')
            let res = response.data
            resolve(res)
          }).catch(error => {
            Vue.$log.debug(error)
            reject(error)
          })
      })
    },
    getIGMPPort (context) {
      Vue.$log.debug('actions getIGMPPort')
      return new Promise((resolve, reject) => {
        instance
          .get(`${PREFIX_URL}/igmp/port/interface`, {
            headers: {
              'content-type': 'application/json',
              authorization: `Bearer ${state.currentUser.auth}`
            }
          }).then(response => {
            Vue.$log.debug('receive getIGMPPort')
            let res = response.data
            resolve(res)
          }).catch(error => {
            Vue.$log.debug(error)
            reject(error)
          })
      })
    },
    delIGMPPort (context, data) {
      // Vue.$log.debug('actions delIGMPPort')
      // return new Promise((resolve, reject) => {
      //   instance
      //     .delete(`${PREFIX_URL}/igmp/port/interface`, {
      //       headers: {
      //         'content-type': 'application/json',
      //         authorization: `Bearer ${state.currentUser.auth}`
      //       },
      //       data: {
      //         idx: data
      //       }
      //     }).then(response => {
      //       Vue.$log.debug('receive setIGMPPort')
      //       let res = response.data
      //       resolve(res)
      //     }).catch(error => {
      //       Vue.$log.debug(error)
      //       reject(error)
      //     })
      // })
    },
    setIGMPPort (context, status) {
      Vue.$log.debug('actions setIGMPPort')
      return new Promise((resolve, reject) => {
        instance
          .put(`${PREFIX_URL}/igmp/port/interfacelist`,
            status
            , {
              headers: {
                'content-type': 'application/json',
                authorization: `Bearer ${state.currentUser.auth}`
              }
            }).then(response => {
            Vue.$log.debug('receive setIGMPPort')
            let res = response.data
            resolve(res)
          }).catch(error => {
            Vue.$log.debug(error)
            reject(error)
          })
      })
    },
    addIGMPPort (context, status) {
      Vue.$log.debug('actions addIGMPPort')
      return new Promise((resolve, reject) => {
        instance
          .post(`${PREFIX_URL}/igmp/port/interfacelist`,
            status
            , {
              headers: {
                'content-type': 'application/json',
                authorization: `Bearer ${state.currentUser.auth}`
              }
            }).then(response => {
            Vue.$log.debug('receive addIGMPPort')
            let res = response.data
            resolve(res)
          }).catch(error => {
            Vue.$log.debug(error)
            reject(error)
          })
      })
    },
    addIGMPVlanConfig (context, status) {
      Vue.$log.debug('actions addIGMPVlanConfig')
      return new Promise((resolve, reject) => {
        instance
          .post(`${PREFIX_URL}/igmp/vlan/interface`, {
            'idx': status.key,
            'data': status.data
          }, {
            headers: {
              'content-type': 'application/json',
              authorization: `Bearer ${state.currentUser.auth}`
            }
          }).then(response => {
            Vue.$log.debug('receive addIGMPVlanConfig')
            let res = response.data
            resolve(res)
          }).catch(error => {
            Vue.$log.error(error)
            reject(error)
          })
      })
    },
    setIGMPVlanConfig (context, status) {
      Vue.$log.debug('actions setIGMPVlanConfig')
      return new Promise((resolve, reject) => {
        instance
          .put(`${PREFIX_URL}/igmp/vlan/interface`, {
            'idx': '' + status.key,
            'data': status.val
          }, {
            headers: {
              'content-type': 'application/json',
              authorization: `Bearer ${state.currentUser.auth}`
            },
            timeout: 10000
          }).then(response => {
            Vue.$log.debug('receive setIGMPVlanConfig')
            let res = response.data
            resolve(res)
          }).catch(error => {
            Vue.$log.error(error)
            reject(error)
          })
      })
    },
    getIGMPVlanConfig (context) {
      Vue.$log.debug('actions getIGMPVlanConfig')
      return new Promise((resolve, reject) => {
        instance
          .get(`${PREFIX_URL}/igmp/vlan/interface`, {
            headers: {
              'content-type': 'application/json',
              authorization: `Bearer ${state.currentUser.auth}`
            }
          }).then(response => {
            Vue.$log.debug('receive getIGMPVlanConfig')
            let res = response.data
            resolve(res)
          }).catch(error => {
            Vue.$log.error(error)
            reject(error)
          })
      })
    },
    getIGMPStatistics (context) {
      Vue.$log.debug('actions getIGMPStatistics')
      return new Promise((resolve, reject) => {
        instance
          .get(`${PREFIX_URL}/igmp/interface/vlan`, {
            headers: {
              'content-type': 'application/json',
              authorization: `Bearer ${state.currentUser.auth}`
            }
          }).then(response => {
            Vue.$log.debug('receive getIGMPStatistics')
            let res = response.data
            resolve(res)
          }).catch(error => {
            Vue.$log.debug(error)
            reject(error)
          })
      })
    },
    getIGMPgroups (context) {
      Vue.$log.debug('actions getIGMPgroups')
      return new Promise((resolve, reject) => {
        instance
          .get(`${PREFIX_URL}/igmp/group/status`, {
            headers: {
              'content-type': 'application/json',
              authorization: `Bearer ${state.currentUser.auth}`
            }
          }).then(response => {
            Vue.$log.debug('receive getIGMPgroups')
            let res = response.data
            resolve(res)
          }).catch(error => {
            Vue.$log.debug(error)
            reject(error)
          })
      })
    },
    // Qos setting
    getQosMode (context) {
      Vue.$log.debug('actions getQosMode')
      return new Promise((resolve, reject) => {
        instance
          .get(`${PREFIX_URL}/qos/mode`, {
            headers: {
              'content-type': 'application/json',
              authorization: `Bearer ${state.currentUser.auth}`
            }
          }).then(response => {
            Vue.$log.debug('receive getQosMode')
            resolve(response)
          }).catch(error => {
            Vue.$log.debug(error)
            reject(error)
          })
      })
    },
    setQosMode (context, status) {
      Vue.$log.debug('actions setQosMode')
      return new Promise((resolve, reject) => {
        instance
          .put(`${PREFIX_URL}/qos/mode`, {
            'idx': status.key,
            'data': status.val
          }, {
            headers: {
              'content-type': 'application/json',
              authorization: `Bearer ${state.currentUser.auth}`
            }
          }).then(response => {
            Vue.$log.debug('receive setQosMode')
            resolve(response)
          }).catch(error => {
            Vue.$log.error(error)
            reject(error)
          })
      })
    },
    getQosDefault (context) {
      Vue.$log.debug('actions getQosDefault')
      return new Promise((resolve, reject) => {
        instance
          .get(`${PREFIX_URL}/qos/default`, {
            headers: {
              'content-type': 'application/json',
              authorization: `Bearer ${state.currentUser.auth}`
            }
          }).then(response => {
            Vue.$log.debug('receive getQosDefault')
            resolve(response)
          }).catch(error => {
            Vue.$log.debug(error)
            reject(error)
          })
      })
    },
    setQosDefault (context, status) {
      Vue.$log.debug('actions setQosDefault')
      return new Promise((resolve, reject) => {
        instance
          .put(`${PREFIX_URL}/qos/default`, {
            'idx': status.key,
            'data': status.val
          }, {
            headers: {
              'content-type': 'application/json',
              authorization: `Bearer ${state.currentUser.auth}`
            }
          }).then(response => {
            Vue.$log.debug('receive setQosDefault')
            resolve(response)
          }).catch(error => {
            Vue.$log.error(error)
            reject(error)
          })
      })
    },
    getQosDscp (context) {
      Vue.$log.debug('actions getQosDscp')
      return new Promise((resolve, reject) => {
        instance
          .get(`${PREFIX_URL}/qos/dscp`, {
            headers: {
              'content-type': 'application/json',
              authorization: `Bearer ${state.currentUser.auth}`
            }
          }).then(response => {
            Vue.$log.debug('receive getQosDscp')
            resolve(response)
          }).catch(error => {
            Vue.$log.debug(error)
            reject(error)
          })
      })
    },
    setQosDscp (context, status) {
      Vue.$log.debug('actions setQosDscp')
      return new Promise((resolve, reject) => {
        instance
          .put(`${PREFIX_URL}/qos/dscp`, {
            'idx': status.key,
            'data': status.val
          }, {
            headers: {
              'content-type': 'application/json',
              authorization: `Bearer ${state.currentUser.auth}`
            }
          }).then(response => {
            Vue.$log.debug('receive setQosDscp')
            resolve(response)
          }).catch(error => {
            Vue.$log.error(error)
            reject(error)
          })
      })
    },
    getQosPcp (context) {
      Vue.$log.debug('actions getQosPcp')
      return new Promise((resolve, reject) => {
        instance
          .get(`${PREFIX_URL}/qos/pcp`, {
            headers: {
              'content-type': 'application/json',
              authorization: `Bearer ${state.currentUser.auth}`
            }
          }).then(response => {
            Vue.$log.debug('receive getQosPcp')
            resolve(response)
          }).catch(error => {
            Vue.$log.debug(error)
            reject(error)
          })
      })
    },
    setQosPcp (context, status) {
      Vue.$log.debug('actions setQosPcp')
      return new Promise((resolve, reject) => {
        instance
          .put(`${PREFIX_URL}/qos/pcp`, {
            'idx': status.key,
            'data': status.val
          }, {
            headers: {
              'content-type': 'application/json',
              authorization: `Bearer ${state.currentUser.auth}`
            }
          }).then(response => {
            Vue.$log.debug('receive setQosPcp')
            resolve(response)
          }).catch(error => {
            Vue.$log.error(error)
            reject(error)
          })
      })
    },
    // RSTP
    getRSTPconfig (context) {
      Vue.$log.debug('actions getRSTPconfig')
      return new Promise((resolve, reject) => {
        instance
          .get(`${PREFIX_URL}/rstp`, {
            headers: {
              'content-type': 'application/json',
              authorization: `Bearer ${state.currentUser.auth}`
            }
          }).then(response => {
            Vue.$log.debug(`receive ${PREFIX_URL}/rstp`)
            let res = response.data
            resolve(res)
          }).catch(error => {
            Vue.$log.debug(error)
            reject(error)
          })
      })
    },
    setRSTPconfig (context, status) {
      Vue.$log.debug('actions setRSTPconfig')
      return new Promise((resolve, reject) => {
        instance
          .put(`${PREFIX_URL}/rstp`, {
            'idx': status.key,
            'data': status.val
          }, {
            headers: {
              'content-type': 'application/json',
              authorization: `Bearer ${state.currentUser.auth}`
            },
            timeout: 10000
          }).then(response => {
            Vue.$log.debug('receive setRSTPconfig')
            let res = response.data
            resolve(res)
          }).catch(error => {
            Vue.$log.debug(error)
            reject(error)
          })
      })
    },
    getRSTPinterface (context) {
      Vue.$log.debug('actions getRSTPinterface')
      return new Promise((resolve, reject) => {
        instance
          .get(`${PREFIX_URL}/rstp/interface`, {
            headers: {
              'content-type': 'application/json',
              authorization: `Bearer ${state.currentUser.auth}`
            }
          }).then(response => {
            Vue.$log.debug(`receive ${PREFIX_URL}/rstp/interface`)
            let res = response.data
            resolve(res)
          }).catch(error => {
            Vue.$log.debug(error)
            reject(error)
          })
      })
    },
    setRSTPinterface (context, status) {
      Vue.$log.debug('actions setRSTPinterface')
      return new Promise((resolve, reject) => {
        instance
          .put(`${PREFIX_URL}/rstp/interfacelist`,
            status
            , {
              headers: {
                'content-type': 'application/json',
                authorization: `Bearer ${state.currentUser.auth}`
              }
            }).then(response => {
            Vue.$log.debug('receive setRSTPinterface')
            let res = response.data
            resolve(res)
          }).catch(error => {
            Vue.$log.debug(error)
            reject(error)
          })
      })
    },
    getRSTPpriority (context) {
      Vue.$log.debug('actions getRSTPpriority')
      return new Promise((resolve, reject) => {
        instance
          .get(`${PREFIX_URL}/rstp/priority`, {
            headers: {
              'content-type': 'application/json',
              authorization: `Bearer ${state.currentUser.auth}`
            }
          }).then(response => {
            Vue.$log.debug(`receive ${PREFIX_URL}/rstp/priority`)
            let res = response.data
            resolve(res)
          }).catch(error => {
            Vue.$log.debug(error)
            reject(error)
          })
      })
    },
    setRSTPpriority (context, status) {
      Vue.$log.debug('actions setRSTPpriority')
      return new Promise((resolve, reject) => {
        instance
          .put(`${PREFIX_URL}/rstp/priority`, {
            'idx': status.key,
            'data': status.val
          }, {
            headers: {
              'content-type': 'application/json',
              authorization: `Bearer ${state.currentUser.auth}`
            }
          }).then(response => {
            Vue.$log.debug('receive setRSTPpriority')
            let res = response.data
            resolve(res)
          }).catch(error => {
            Vue.$log.debug(error)
            reject(error)
          })
      })
    },
    getRSTProle (context) {
      Vue.$log.debug('actions getRSTProle')
      return new Promise((resolve, reject) => {
        instance
          .get(`${PREFIX_URL}/rstp/interface/role`, {
            headers: {
              'content-type': 'application/json',
              authorization: `Bearer ${state.currentUser.auth}`
            }
          }).then(response => {
            Vue.$log.debug(`receive ${PREFIX_URL}/rstp/interface/role`)
            let res = response.data
            resolve(res)
          }).catch(error => {
            Vue.$log.debug(error)
            reject(error)
          })
      })
    },
    getRSTPstate (context) {
      Vue.$log.debug('actions getRSTPstate')
      return new Promise((resolve, reject) => {
        instance
          .get(`${PREFIX_URL}/rstp/interface/state`, {
            headers: {
              'content-type': 'application/json',
              authorization: `Bearer ${state.currentUser.auth}`
            }
          }).then(response => {
            Vue.$log.debug(`receive ${PREFIX_URL}/rstp/interface/state`)
            let res = response.data
            resolve(res)
          }).catch(error => {
            Vue.$log.debug(error)
            reject(error)
          })
      })
    },
    // Port Mirroring
    getMirroring (context) {
      Vue.$log.debug('actions getMirroring')
      return new Promise((resolve, reject) => {
        instance
          .get(`${PREFIX_URL}/mirror`, {
            headers: {
              'content-type': 'application/json',
              authorization: `Bearer ${state.currentUser.auth}`
            }
          }).then(response => {
            Vue.$log.debug('receive getMirroring')
            let res = response.data
            resolve(res)
          }).catch(error => {
            Vue.$log.debug(error)
            reject(error)
          })
      })
    },
    async setMirroring (context, status) {
      await context.dispatch('delMirroring')
      Vue.$log.debug('actions setMirroring')
      return new Promise((resolve, reject) => {
        instance
          .post(`${PREFIX_URL}/mirror`, {data: [
            {
              key: '' + status.key,
              val: status.val
            }]
          }, {
            headers: {
              'content-type': 'application/json',
              authorization: `Bearer ${state.currentUser.auth}`
            }
          }).then(response => {
            Vue.$log.debug(`put ${PREFIX_URL}/mirror`)
            resolve(response)
          }).catch(error => {
            Vue.$log.debug(error)
            reject(error)
          })
      })
    },
    delMirroring (context) {
      Vue.$log.debug('actions setMirroring')
      return new Promise((resolve, reject) => {
        instance
          .delete(`${PREFIX_URL}/mirror`, {
            headers: {
              'content-type': 'application/json',
              authorization: `Bearer ${state.currentUser.auth}`
            },
            data: {
              idx: ['1']
            }
          }).then(response => {
            // Vue.$log.debug(`put ${PREFIX_URL}/mirror`)
            resolve(response)
          }).catch(error => {
            Vue.$log.debug(error)
            reject(error)
          })
      })
    },
    // LLDP setting
    getLLDPglobalConfig (context) {
      Vue.$log.debug('actions getLLDPglobalConfig')
      return new Promise((resolve, reject) => {
        instance
          .get(`${PREFIX_URL}/lldp`, {
            headers: {
              'content-type': 'application/json',
              authorization: `Bearer ${state.currentUser.auth}`
            }
          }).then(response => {
            Vue.$log.debug(`receive ${PREFIX_URL}/lldp`)
            let res = response.data
            resolve(res)
          }).catch(error => {
            Vue.$log.debug(error)
            reject(error)
          })
      })
    },
    setLLDPglobalConfig (context, status) {
      Vue.$log.debug('actions setLLDPglobalConfig')
      return new Promise((resolve, reject) => {
        instance
          .put(`${PREFIX_URL}/lldp`, {
            'data': status
          }, {
            headers: {
              'content-type': 'application/json',
              authorization: `Bearer ${state.currentUser.auth}`
            }
          }).then(response => {
            Vue.$log.debug(`put ${PREFIX_URL}/lldp`)
            let res = response.data
            resolve(res)
          }).catch(error => {
            Vue.$log.debug(error)
            reject(error)
          })
      })
    },
    getLLDPinterfaceConfig (context) {
      Vue.$log.debug('actions getLLDPinterfaceConfig')
      return new Promise((resolve, reject) => {
        instance
          .get(`${PREFIX_URL}/lldp/interface`, {
            headers: {
              'content-type': 'application/json',
              authorization: `Bearer ${state.currentUser.auth}`
            }
          }).then(response => {
            Vue.$log.debug(`get ${PREFIX_URL}/lldp/interface`)
            let res = response.data
            resolve(res)
          }).catch(error => {
            Vue.$log.debug(error)
            reject(error)
          })
      })
    },
    setLLDPinterfaceConfig (context, status) {
      Vue.$log.debug('actions setLLDPinterfaceConfig')
      return new Promise((resolve, reject) => {
        instance
          .put(`${PREFIX_URL}/lldp/interface`, {
            'idx': status.key,
            'data': status.val
          }, {
            headers: {
              'content-type': 'application/json',
              authorization: `Bearer ${state.currentUser.auth}`
            }
          }).then(response => {
            Vue.$log.debug(`get ${PREFIX_URL}/lldp/interface`)
            let res = response.data
            resolve(res)
          }).catch(error => {
            Vue.$log.debug(error)
            reject(error)
          })
      })
    },
    getLLDPNeighbors (context) {
      Vue.$log.debug('actions getLLDPNeighbors')
      return new Promise((resolve, reject) => {
        instance
          .get(`${PREFIX_URL}/lldp/neighbors/status`, {
            headers: {
              'content-type': 'application/json',
              authorization: `Bearer ${state.currentUser.auth}`
            }
          }).then(response => {
            Vue.$log.debug(`get ${PREFIX_URL}/lldp/neighbors/status`)
            let res = response.data
            resolve(res)
          }).catch(error => {
            Vue.$log.debug(error)
            reject(error)
          })
      })
    },
    firmwareUpdateExit (context) {
      Vue.$log.debug('actions firmwareUpdateExit')
      return new Promise((resolve, reject) => {
        instance
          .post(`${PREFIX_URL}/users/exit`, {
          },
          {
            headers: {
              'content-type': 'application/json',
              authorization: `Bearer ${state.currentUser.auth}`
            }
          }).then(response => {
            Vue.$log.debug(`get ${PREFIX_URL}/users/exit`)
            resolve(response)
          }).catch(error => {
            Vue.$log.debug(error)
            reject(error)
          })
      })
    },
    getTransceiver (context, key) {
      Vue.$log.debug('actions getTransceiver')
      return new Promise((resolve, reject) => {
        instance
          .get(`${PREFIX_URL}/ports/transceiver`, {
            headers: {
              'content-type': 'application/json',
              authorization: `Bearer ${state.currentUser.auth}`
            },
            params: {
              'key': key
            }
          }).then(response => {
            Vue.$log.debug(`receive ${PREFIX_URL}/ports/transciver`)
            resolve(response.data)
          }).catch(error => {
            Vue.$log.error(error)
            reject(error)
          })
      })
    },
    getFecStatus (context) {
      Vue.$log.debug('actions getFecStatus')
      return new Promise((resolve, reject) => {
        instance
          .get(`${PREFIX_URL}/ports/fec`, {
            headers: {
              'content-type': 'application/json',
              authorization: `Bearer ${state.currentUser.auth}`
            }
          }).then(response => {
            Vue.$log.debug(`receive ${PREFIX_URL}/ports/fec`)
            resolve(response.data)
          }).catch(error => {
            Vue.$log.error(error)
            reject(error)
          })
      })
    },
    getWebConfig (context) {
      Vue.$log.debug('actions getWebConfig')
      return new Promise((resolve, reject) => {
        instance
          .get(`${PREFIX_URL}/system/web/config`, {
            headers: {
            }
          }).then(response => {
            Vue.$log.debug(`receive ${PREFIX_URL}/system/web/config`)
            resolve(response.data)
          }).catch(error => {
            Vue.$log.error(error)
            reject(error)
          })
      })
    },
    setWebConfig (context, lang) {
      Vue.$log.debug('actions getWebConfig')
      return new Promise((resolve, reject) => {
        instance
          .put(`${PREFIX_URL}/system/web/config`, {
            'Language': lang
          }, {
            headers: {
              'content-type': 'application/json',
              authorization: `Bearer ${state.currentUser.auth}`
            }
          }).then(response => {
            Vue.$log.debug(`put ${PREFIX_URL}/system/web/config`)
            resolve(response.data)
          }).catch(error => {
            Vue.$log.error(error)
            reject(error)
          })
      })
    },
    postUpgrade (context) {
      Vue.$log.debug('actions postLocalChunkUpload')
      return new Promise((resolve, reject) => {
        instance
          .post(`${PREFIX_URL}/firmware/update/chunk/upgrade`, {
          },
          {
            headers: {
              'content-type': 'application/json',
              authorization: `Bearer ${state.currentUser.auth}`
            }
          }).then(response => {
            Vue.$log.debug(`receive ${PREFIX_URL}/firmware/update/chunk/upgrade`)
            Vue.$log.debug(response)
            resolve(response)
          }).catch(error => {
            reject(error)
          })
      })
    },
    getSystemError (context) {
      Vue.$log.debug('actions getSystemError')
      return new Promise((resolve, reject) => {
        instance
          .get(`${PREFIX_URL}/system/error`, {
            headers: {
              'content-type': 'application/json',
              authorization: `Bearer ${state.currentUser.auth}`
            }
          }).then(response => {
            Vue.$log.debug(`receive ${PREFIX_URL}/system/error`)
            resolve(response)
          }).catch(error => {
            Vue.$log.debug(error)
            reject(error)
          })
      })
    },
    setSystemError (context, status) {
      Vue.$log.debug('actions postLocalChunkUpload')
      return new Promise((resolve, reject) => {
        instance
          .put(`${PREFIX_URL}/system/error`, {
            'resolve': [
              status
            ]
          },
          {
            headers: {
              'content-type': 'application/json',
              authorization: `Bearer ${state.currentUser.auth}`
            }
          }).then(response => {
            Vue.$log.debug(`receive ${PREFIX_URL}/system/error`)
            Vue.$log.debug(response)
            resolve(response)
          }).catch(error => {
            reject(error)
          })
      })
    },
    getSysLog (context) {
      Vue.$log.debug('actions getSysLog')
      return new Promise((resolve, reject) => {
        instance
          .get(`${PREFIX_URL}/system/syslog`, {
            headers: {
              'content-type': 'application/octet-stream',
              authorization: `Bearer ${state.currentUser.auth}`
            },
            responseType: 'blob'
          }).then(response => {
            Vue.$log.debug(`receive ${PREFIX_URL}/system/syslog`)
            resolve(response)
          }).catch(error => {
            Vue.$log.debug(error)
            reject(error)
          })
      })
    },
    getQosDebug (context) {
      Vue.$log.debug('actions getQosDebug')
      return new Promise((resolve, reject) => {
        instance
          .get(`${PREFIX_URL}/debug/qos`, {
            headers: {
              'content-type': 'application/json',
              authorization: `Bearer ${state.currentUser.auth}`
            }
          }).then(response => {
            Vue.$log.debug(`receive ${PREFIX_URL}/debug/qos`)
            resolve(response)
          }).catch(error => {
            Vue.$log.debug(error)
            reject(error)
          })
      })
    },
    getLldpDebug (context) {
      Vue.$log.debug('actions getLldpDebug')
      return new Promise((resolve, reject) => {
        instance
          .get(`${PREFIX_URL}/debug/lldp`, {
            headers: {
              'content-type': 'application/json',
              authorization: `Bearer ${state.currentUser.auth}`
            }
          }).then(response => {
            Vue.$log.debug(`receive ${PREFIX_URL}/debug/lldp`)
            resolve(response)
          }).catch(error => {
            Vue.$log.debug(error)
            reject(error)
          })
      })
    },
    setQosDebug (context, status) {
      Vue.$log.debug('actions getQosDebug')
      return new Promise((resolve, reject) => {
        instance
          .put(`${PREFIX_URL}/debug/qos`, {
            'Flag': status
          },
          {
            headers: {
              'content-type': 'application/json',
              authorization: `Bearer ${state.currentUser.auth}`
            }
          }).then(response => {
            Vue.$log.debug(`receive ${PREFIX_URL}/debug/qos`)
            resolve(response)
          }).catch(error => {
            Vue.$log.debug(error)
            reject(error)
          })
      })
    },
    setLldpDebug (context, status) {
      Vue.$log.debug('actions getLldpDebug')
      return new Promise((resolve, reject) => {
        instance
          .put(`${PREFIX_URL}/debug/lldp`, {
            'Level': status
          },
          {
            headers: {
              'content-type': 'application/json',
              authorization: `Bearer ${state.currentUser.auth}`
            }
          }).then(response => {
            Vue.$log.debug(`receive ${PREFIX_URL}/debug/lldp`)
            resolve(response)
          }).catch(error => {
            Vue.$log.debug(error)
            reject(error)
          })
      })
    },
    getSystemSnmpService (context) {
      Vue.$log.debug('actions getSystemSnmpService')
      return new Promise((resolve, reject) => {
        instance
          .get(`${PREFIX_URL}/snmp/service`, {
            headers: {
              'content-type': 'application/json',
              authorization: `Bearer ${state.currentUser.auth}`
            }
          }).then(response => {
            Vue.$log.debug(`receive ${PREFIX_URL}/snmp/service`)
            resolve(response)
          }).catch(error => {
            Vue.$log.debug(error)
            reject(error)
          })
      })
    },
    getSystemSnmpCommunity (context) {
      Vue.$log.debug('actions getSystemSnmpCommunity')
      return new Promise((resolve, reject) => {
        instance
          .get(`${PREFIX_URL}/snmp/community`, {
            headers: {
              'content-type': 'application/json',
              authorization: `Bearer ${state.currentUser.auth}`
            }
          }).then(response => {
            Vue.$log.debug(`receive ${PREFIX_URL}/snmp/community`)
            resolve(response)
          }).catch(error => {
            Vue.$log.debug(error)
            reject(error)
          })
      })
    },
    getSystemSnmpSecurity (context) {
      Vue.$log.debug('actions getSystemSnmpSecurity')
      return new Promise((resolve, reject) => {
        instance
          .get(`${PREFIX_URL}/snmp/security`, {
            headers: {
              'content-type': 'application/json',
              authorization: `Bearer ${state.currentUser.auth}`
            }
          }).then(response => {
            Vue.$log.debug(`receive ${PREFIX_URL}/snmp/security`)
            resolve(response)
          }).catch(error => {
            Vue.$log.debug(error)
            reject(error)
          })
      })
    },
    getSystemSnmpTrapEvent (context) {
      Vue.$log.debug('actions getSystemSnmpTrapEvent')
      return new Promise((resolve, reject) => {
        instance
          .get(`${PREFIX_URL}/snmp/trap/event`, {
            headers: {
              'content-type': 'application/json',
              authorization: `Bearer ${state.currentUser.auth}`
            }
          }).then(response => {
            Vue.$log.debug(`receive ${PREFIX_URL}/snmp/trap/event`)
            resolve(response)
          }).catch(error => {
            Vue.$log.debug(error)
            reject(error)
          })
      })
    },
    getSystemSnmpAddress (context) {
      Vue.$log.debug('actions getSystemSnmpAddress')
      return new Promise((resolve, reject) => {
        instance
          .get(`${PREFIX_URL}/snmp/address`, {
            headers: {
              'content-type': 'application/json',
              authorization: `Bearer ${state.currentUser.auth}`
            }
          }).then(response => {
            Vue.$log.debug(`receive ${PREFIX_URL}/snmp/address`)
            resolve(response)
          }).catch(error => {
            Vue.$log.debug(error)
            reject(error)
          })
      })
    },
    setSystemSnmpService (context, data) {
      Vue.$log.debug('action setSystemSnmpService')
      return new Promise((resolve, reject) => {
        instance
          .put(`${PREFIX_URL}/snmp/service`, {
            'EnableService': data.EnableService
          }, {
            headers: {
              'content-type': 'application/json',
              authorization: `Bearer ${state.currentUser.auth}`
            }
          }).then(response => {
            Vue.$log.debug(`receive ${PREFIX_URL}/snmp/service`)
            resolve(response)
          }).catch(error => {
            Vue.$log.debug(error)
            reject(error)
          })
      })
    },
    addSystemSnmpCommunity (context, data) {
      Vue.$log.debug('action addSystemSnmpCommunity')
      return new Promise((resolve, reject) => {
        instance
          .post(`${PREFIX_URL}/snmp/community`, {
            'idx': 'USER',
            'data': {
              'CommunityName': data.CommunityName,
              'Version': data.Version
            }
          }, {
            headers: {
              'content-type': 'application/json',
              authorization: `Bearer ${state.currentUser.auth}`
            }
          }).then(response => {
            Vue.$log.debug(`receive ${PREFIX_URL}/snmp/community`)
            resolve(response)
          }).catch(error => {
            Vue.$log.debug(error)
            reject(error)
          })
      })
    },
    setSystemSnmpCommunity (context, data) {
      Vue.$log.debug('action setSystemSnmpCommunity')
      return new Promise((resolve, reject) => {
        instance
          .put(`${PREFIX_URL}/snmp/community`, {
            'idx': 'USER',
            'data': {
              'CommunityName': data.CommunityName,
              'Version': data.Version
            }
          }, {
            headers: {
              'content-type': 'application/json',
              authorization: `Bearer ${state.currentUser.auth}`
            }
          }).then(response => {
            Vue.$log.debug(`receive ${PREFIX_URL}/snmp/community`)
            resolve(response)
          }).catch(error => {
            Vue.$log.debug(error)
            reject(error)
          })
      })
    },
    delSystemSnmpCommunity (context, data) {
      Vue.$log.debug('action delSystemSnmpCommunity')
      return new Promise((resolve, reject) => {
        instance
          .delete(`${PREFIX_URL}/snmp/community`, {
            headers: {
              'content-type': 'application/json',
              authorization: `Bearer ${state.currentUser.auth}`
            },
            data: {
              idx: ['USER']
            }
          }).then((response) => {
            Vue.$log.debug(`receive ${PREFIX_URL}/snmp/community`)
            resolve(response.data)
          }).catch((error) => {
            Vue.$log.debug(error)
            reject(error)
          })
      })
    },
    addSystemSnmpSecurity (context, data) {
      Vue.$log.debug('action addSystemSnmpSecurity')
      return new Promise((resolve, reject) => {
        instance
          .post(`${PREFIX_URL}/snmp/security`, {
            'idx': data.idx,
            'data': {
              'AuthProtocol': data.AuthProtocol,
              'AuthKey': data.AuthKey,
              'PrivacyProtocol': data.PrivacyProtocol,
              'PrivacyKey': data.PrivacyKey
            }
          }, {
            headers: {
              'content-type': 'application/json',
              authorization: `Bearer ${state.currentUser.auth}`
            }
          }).then((response) => {
            Vue.$log.debug(`receive ${PREFIX_URL}/snmp/security`)
            resolve(response.data)
          }).catch((error) => {
            Vue.$log.debug(error)
            reject(error)
          })
      })
    },
    setSystemSnmpSecurity (context, data) {
      Vue.$log.debug('action setSystemSnmpSecurity')
      return new Promise((resolve, reject) => {
        instance
          .put(`${PREFIX_URL}/snmp/security`, {
            'idx': data.idx,
            'data': {
              'AuthProtocol': data.AuthProtocol,
              'AuthKey': data.AuthKey,
              'PrivacyProtocol': data.PrivacyProtocol,
              'PrivacyKey': data.PrivacyKey
            }
          }, {
            headers: {
              'content-type': 'application/json',
              authorization: `Bearer ${state.currentUser.auth}`
            }
          }).then((response) => {
            Vue.$log.debug(`receive ${PREFIX_URL}/snmp/security`)
            resolve(response.data)
          }).catch((error) => {
            Vue.$log.debug(error)
            reject(error)
          })
      })
    },
    delSystemSnmpSecurity (context, data) {
      Vue.$log.debug('action delSystemSnmpSecurity')
      return new Promise((resolve, reject) => {
        instance
          .delete(`${PREFIX_URL}/snmp/security`, {
            headers: {
              'content-type': 'application/json',
              authorization: `Bearer ${state.currentUser.auth}`
            },
            data: {
              idx: [data]
            }
          }).then((response) => {
            Vue.$log.debug(`receive ${PREFIX_URL}/snmp/security`)
            resolve(response.data)
          }).catch((error) => {
            Vue.$log.debug(error)
            reject(error)
          })
      })
    },
    setSystemSnmpTrapEvent (context, data) {
      Vue.$log.debug('action setSystemSnmpTrapEvent')
      return new Promise((resolve, reject) => {
        instance
          .put(`${PREFIX_URL}/snmp/trap/event`, {
            'ColdStart': data.ColdStart,
            'WarmStart': data.WarmStart,
            'LinkUp': data.LinkUp,
            'LinkDown': data.LinkDown
          }, {
            headers: {
              'content-type': 'application/json',
              authorization: `Bearer ${state.currentUser.auth}`
            }
          }).then(response => {
            Vue.$log.debug(`receive ${PREFIX_URL}/snmp/trap/event`)
            resolve(response)
          }).catch(error => {
            Vue.$log.debug(error)
            reject(error)
          })
      })
    },
    addSystemSnmpAddress (context, data) {
      Vue.$log.debug('action addSystemSnmpAddress')
      return new Promise((resolve, reject) => {
        instance
          .post(`${PREFIX_URL}/snmp/address`, {
            'idx': data.idx,
            'data': {
              'Address': data.Address,
              'Port': '162',
              'NotifyType': 'Trap',
              'UserName': data.UserName,
              'Version': data.Version
            }
          }, {
            headers: {
              'content-type': 'application/json',
              authorization: `Bearer ${state.currentUser.auth}`
            }
          }).then((response) => {
            Vue.$log.debug(`receive ${PREFIX_URL}/snmp/address`)
            resolve(response.data)
          }).catch((error) => {
            Vue.$log.debug(error)
            reject(error)
          })
      })
    },
    setSystemSnmpAddress (context, data) {
      Vue.$log.debug('action setSystemSnmpAddress')
      return new Promise((resolve, reject) => {
        instance
          .put(`${PREFIX_URL}/snmp/address`, {
            'idx': data.idx,
            'data': {
              'Address': data.Address,
              'Port': '162',
              'NotifyType': 'Trap',
              'UserName': data.UserName,
              'Version': data.Version
            }
          }, {
            headers: {
              'content-type': 'application/json',
              authorization: `Bearer ${state.currentUser.auth}`
            }
          }).then((response) => {
            Vue.$log.debug(`receive ${PREFIX_URL}/snmp/address`)
            resolve(response.data)
          }).catch((error) => {
            Vue.$log.debug(error)
            reject(error)
          })
      })
    },
    delSystemSnmpAddress (context, data) {
      Vue.$log.debug('action delSystemSnmpAddress')
      return new Promise((resolve, reject) => {
        instance
          .delete(`${PREFIX_URL}/snmp/address`, {
            headers: {
              'content-type': 'application/json',
              authorization: `Bearer ${state.currentUser.auth}`
            },
            data: {
              idx: [data]
            }
          }).then((response) => {
            Vue.$log.debug(`receive ${PREFIX_URL}/snmp/address`)
            resolve(response.data)
          }).catch((error) => {
            Vue.$log.debug(error)
            reject(error)
          })
      })
    }
  },
  getters: {
    getTopModalName (state) {
      return state.modalList[state.modalList.length - 1]
    },
    getAclList (state) {
      return state.aclList
    },
    getModalData (state) {
      return state.modalData
    },
    getSwVersion (state) {
      return state.boardInfo
    }
  }
}
export default module



// WEBPACK FOOTER //
// ./src/store/app/aricent.js